var ot = Object.defineProperty;
var ut = (t, e, n) => e in t ? ot(t, e, { enumerable: !0, configurable: !0, writable: !0, value: n }) : t[e] = n;
var j = (t, e, n) => (ut(t, typeof e != "symbol" ? e + "" : e, n), n);
function O() {
}
const Qe = (t) => t;
function Xe(t, e) {
  for (const n in e)
    t[n] = e[n];
  return (
    /** @type {T & S} */
    t
  );
}
function xe(t) {
  return t();
}
function Ce() {
  return /* @__PURE__ */ Object.create(null);
}
function Q(t) {
  t.forEach(xe);
}
function ce(t) {
  return typeof t == "function";
}
function K(t, e) {
  return t != t ? e == e : t !== e || t && typeof t == "object" || typeof t == "function";
}
let de;
function Se(t, e) {
  return t === e ? !0 : (de || (de = document.createElement("a")), de.href = e, t === de.href);
}
function ft(t) {
  return Object.keys(t).length === 0;
}
function ht(t, e, n, l) {
  if (t) {
    const c = et(t, e, n, l);
    return t[0](c);
  }
}
function et(t, e, n, l) {
  return t[1] && l ? Xe(n.ctx.slice(), t[1](l(e))) : n.ctx;
}
function gt(t, e, n, l) {
  if (t[2] && l) {
    const c = t[2](l(n));
    if (e.dirty === void 0)
      return c;
    if (typeof c == "object") {
      const i = [], a = Math.max(e.dirty.length, c.length);
      for (let r = 0; r < a; r += 1)
        i[r] = e.dirty[r] | c[r];
      return i;
    }
    return e.dirty | c;
  }
  return e.dirty;
}
function mt(t, e, n, l, c, i) {
  if (c) {
    const a = et(e, n, l, i);
    t.p(a, c);
  }
}
function dt(t) {
  if (t.ctx.length > 32) {
    const e = [], n = t.ctx.length / 32;
    for (let l = 0; l < n; l++)
      e[l] = -1;
    return e;
  }
  return -1;
}
function _t(t) {
  return t && ce(t.destroy) ? t.destroy : O;
}
const tt = typeof window < "u";
let pt = tt ? () => window.performance.now() : () => Date.now(), Ee = tt ? (t) => requestAnimationFrame(t) : O;
const ne = /* @__PURE__ */ new Set();
function nt(t) {
  ne.forEach((e) => {
    e.c(t) || (ne.delete(e), e.f());
  }), ne.size !== 0 && Ee(nt);
}
function vt(t) {
  let e;
  return ne.size === 0 && Ee(nt), {
    promise: new Promise((n) => {
      ne.add(e = { c: t, f: n });
    }),
    abort() {
      ne.delete(e);
    }
  };
}
function S(t, e) {
  t.appendChild(e);
}
function lt(t) {
  if (!t)
    return document;
  const e = t.getRootNode ? t.getRootNode() : t.ownerDocument;
  return e && /** @type {ShadowRoot} */
  e.host ? (
    /** @type {ShadowRoot} */
    e
  ) : t.ownerDocument;
}
function wt(t) {
  const e = N("style");
  return e.textContent = "/* empty */", yt(lt(t), e), e.sheet;
}
function yt(t, e) {
  return S(
    /** @type {Document} */
    t.head || t,
    e
  ), e.sheet;
}
function R(t, e, n) {
  t.insertBefore(e, n || null);
}
function k(t) {
  t.parentNode && t.parentNode.removeChild(t);
}
function ye(t, e) {
  for (let n = 0; n < t.length; n += 1)
    t[n] && t[n].d(e);
}
function N(t) {
  return document.createElement(t);
}
function x(t) {
  return document.createElementNS("http://www.w3.org/2000/svg", t);
}
function $(t) {
  return document.createTextNode(t);
}
function M() {
  return $(" ");
}
function me() {
  return $("");
}
function z(t, e, n, l) {
  return t.addEventListener(e, n, l), () => t.removeEventListener(e, n, l);
}
function pe(t) {
  return function(e) {
    return e.stopPropagation(), t.call(this, e);
  };
}
function _(t, e, n) {
  n == null ? t.removeAttribute(e) : t.getAttribute(e) !== n && t.setAttribute(e, n);
}
const Lt = ["width", "height"];
function At(t, e) {
  const n = Object.getOwnPropertyDescriptors(t.__proto__);
  for (const l in e)
    e[l] == null ? t.removeAttribute(l) : l === "style" ? t.style.cssText = e[l] : l === "__value" ? t.value = t[l] = e[l] : n[l] && n[l].set && Lt.indexOf(l) === -1 ? t[l] = e[l] : _(t, l, e[l]);
}
function kt(t, e) {
  Object.keys(e).forEach((n) => {
    Zt(t, n, e[n]);
  });
}
function Zt(t, e, n) {
  const l = e.toLowerCase();
  l in t ? t[l] = typeof t[l] == "boolean" && n === "" ? !0 : n : e in t ? t[e] = typeof t[e] == "boolean" && n === "" ? !0 : n : _(t, e, n);
}
function be(t) {
  return /-/.test(t) ? kt : At;
}
function Et(t) {
  return Array.from(t.childNodes);
}
function Re(t, e) {
  e = "" + e, t.data !== e && (t.data = /** @type {string} */
  e);
}
function Pe(t, e, n, l) {
  n == null ? t.style.removeProperty(e) : t.style.setProperty(e, n, l ? "important" : "");
}
function b(t, e, n) {
  t.classList.toggle(e, !!n);
}
function ct(t, e, { bubbles: n = !1, cancelable: l = !1 } = {}) {
  return new CustomEvent(t, { detail: e, bubbles: n, cancelable: l });
}
class at {
  constructor(e = !1) {
    /**
     * @private
     * @default false
     */
    j(this, "is_svg", !1);
    /** parent for creating node */
    j(this, "e");
    /** html tag nodes */
    j(this, "n");
    /** target */
    j(this, "t");
    /** anchor */
    j(this, "a");
    this.is_svg = e, this.e = this.n = null;
  }
  /**
   * @param {string} html
   * @returns {void}
   */
  c(e) {
    this.h(e);
  }
  /**
   * @param {string} html
   * @param {HTMLElement | SVGElement} target
   * @param {HTMLElement | SVGElement} anchor
   * @returns {void}
   */
  m(e, n, l = null) {
    this.e || (this.is_svg ? this.e = x(
      /** @type {keyof SVGElementTagNameMap} */
      n.nodeName
    ) : this.e = N(
      /** @type {keyof HTMLElementTagNameMap} */
      n.nodeType === 11 ? "TEMPLATE" : n.nodeName
    ), this.t = n.tagName !== "TEMPLATE" ? n : (
      /** @type {HTMLTemplateElement} */
      n.content
    ), this.c(e)), this.i(l);
  }
  /**
   * @param {string} html
   * @returns {void}
   */
  h(e) {
    this.e.innerHTML = e, this.n = Array.from(
      this.e.nodeName === "TEMPLATE" ? this.e.content.childNodes : this.e.childNodes
    );
  }
  /**
   * @returns {void} */
  i(e) {
    for (let n = 0; n < this.n.length; n += 1)
      R(this.t, this.n[n], e);
  }
  /**
   * @param {string} html
   * @returns {void}
   */
  p(e) {
    this.d(), this.h(e), this.i(this.a);
  }
  /**
   * @returns {void} */
  d() {
    this.n.forEach(k);
  }
}
const ve = /* @__PURE__ */ new Map();
let we = 0;
function Rt(t) {
  let e = 5381, n = t.length;
  for (; n--; )
    e = (e << 5) - e ^ t.charCodeAt(n);
  return e >>> 0;
}
function Tt(t, e) {
  const n = { stylesheet: wt(e), rules: {} };
  return ve.set(t, n), n;
}
function Ne(t, e, n, l, c, i, a, r = 0) {
  const s = 16.666 / l;
  let g = `{
`;
  for (let C = 0; C <= 1; C += s) {
    const Z = e + (n - e) * i(C);
    g += C * 100 + `%{${a(Z, 1 - Z)}}
`;
  }
  const m = g + `100% {${a(n, 1 - n)}}
}`, d = `__svelte_${Rt(m)}_${r}`, h = lt(t), { stylesheet: o, rules: u } = ve.get(h) || Tt(h, t);
  u[d] || (u[d] = !0, o.insertRule(`@keyframes ${d} ${m}`, o.cssRules.length));
  const L = t.style.animation || "";
  return t.style.animation = `${L ? `${L}, ` : ""}${d} ${l}ms linear ${c}ms 1 both`, we += 1, d;
}
function Ct(t, e) {
  const n = (t.style.animation || "").split(", "), l = n.filter(
    e ? (i) => i.indexOf(e) < 0 : (i) => i.indexOf("__svelte") === -1
    // remove all Svelte animations
  ), c = n.length - l.length;
  c && (t.style.animation = l.join(", "), we -= c, we || St());
}
function St() {
  Ee(() => {
    we || (ve.forEach((t) => {
      const { ownerNode: e } = t.stylesheet;
      e && k(e);
    }), ve.clear());
  });
}
let fe;
function ue(t) {
  fe = t;
}
function bt() {
  if (!fe)
    throw new Error("Function called outside component initialization");
  return fe;
}
function it() {
  const t = bt();
  return (e, n, { cancelable: l = !1 } = {}) => {
    const c = t.$$.callbacks[e];
    if (c) {
      const i = ct(
        /** @type {string} */
        e,
        n,
        { cancelable: l }
      );
      return c.slice().forEach((a) => {
        a.call(t, i);
      }), !i.defaultPrevented;
    }
    return !0;
  };
}
function Pt(t, e) {
  const n = t.$$.callbacks[e.type];
  n && n.slice().forEach((l) => l.call(this, e));
}
const te = [], Ie = [];
let le = [];
const Ue = [], Nt = /* @__PURE__ */ Promise.resolve();
let Ze = !1;
function It() {
  Ze || (Ze = !0, Nt.then(rt));
}
function he(t) {
  le.push(t);
}
const Le = /* @__PURE__ */ new Set();
let ee = 0;
function rt() {
  if (ee !== 0)
    return;
  const t = fe;
  do {
    try {
      for (; ee < te.length; ) {
        const e = te[ee];
        ee++, ue(e), Ut(e.$$);
      }
    } catch (e) {
      throw te.length = 0, ee = 0, e;
    }
    for (ue(null), te.length = 0, ee = 0; Ie.length; )
      Ie.pop()();
    for (let e = 0; e < le.length; e += 1) {
      const n = le[e];
      Le.has(n) || (Le.add(n), n());
    }
    le.length = 0;
  } while (te.length);
  for (; Ue.length; )
    Ue.pop()();
  Ze = !1, Le.clear(), ue(t);
}
function Ut(t) {
  if (t.fragment !== null) {
    t.update(), Q(t.before_update);
    const e = t.dirty;
    t.dirty = [-1], t.fragment && t.fragment.p(t.ctx, e), t.after_update.forEach(he);
  }
}
function Ot(t) {
  const e = [], n = [];
  le.forEach((l) => t.indexOf(l) === -1 ? e.push(l) : n.push(l)), n.forEach((l) => l()), le = e;
}
let se;
function Vt() {
  return se || (se = Promise.resolve(), se.then(() => {
    se = null;
  })), se;
}
function Ae(t, e, n) {
  t.dispatchEvent(ct(`${e ? "intro" : "outro"}${n}`));
}
const _e = /* @__PURE__ */ new Set();
let J;
function ae() {
  J = {
    r: 0,
    c: [],
    p: J
    // parent group
  };
}
function ie() {
  J.r || Q(J.c), J = J.p;
}
function v(t, e) {
  t && t.i && (_e.delete(t), t.i(e));
}
function T(t, e, n, l) {
  if (t && t.o) {
    if (_e.has(t))
      return;
    _e.add(t), J.c.push(() => {
      _e.delete(t), l && (n && t.d(1), l());
    }), t.o(e);
  } else
    l && l();
}
const Mt = { duration: 0 };
function Oe(t, e, n, l) {
  let i = e(t, n, { direction: "both" }), a = l ? 0 : 1, r = null, s = null, g = null, m;
  function d() {
    g && Ct(t, g);
  }
  function h(u, L) {
    const C = (
      /** @type {Program['d']} */
      u.b - a
    );
    return L *= Math.abs(C), {
      a,
      b: u.b,
      d: C,
      duration: L,
      start: u.start,
      end: u.start + L,
      group: u.group
    };
  }
  function o(u) {
    const {
      delay: L = 0,
      duration: C = 300,
      easing: Z = Qe,
      tick: B = O,
      css: w
    } = i || Mt, P = {
      start: pt() + L,
      b: u
    };
    u || (P.group = J, J.r += 1), "inert" in t && (u ? m !== void 0 && (t.inert = m) : (m = /** @type {HTMLElement} */
    t.inert, t.inert = !0)), r || s ? s = P : (w && (d(), g = Ne(t, a, u, C, L, Z, w)), u && B(0, 1), r = h(P, C), he(() => Ae(t, u, "start")), vt((H) => {
      if (s && H > s.start && (r = h(s, C), s = null, Ae(t, r.b, "start"), w && (d(), g = Ne(
        t,
        a,
        r.b,
        r.duration,
        0,
        Z,
        i.css
      ))), r) {
        if (H >= r.end)
          B(a = r.b, 1 - a), Ae(t, r.b, "end"), s || (r.b ? d() : --r.group.r || Q(r.group.c)), r = null;
        else if (H >= r.start) {
          const X = H - r.start;
          a = r.a + r.d * Z(X / r.duration), B(a, 1 - a);
        }
      }
      return !!(r || s);
    }));
  }
  return {
    run(u) {
      ce(i) ? Vt().then(() => {
        i = i({ direction: u ? "in" : "out" }), o(u);
      }) : o(u);
    },
    end() {
      d(), r = s = null;
    }
  };
}
function W(t) {
  return (t == null ? void 0 : t.length) !== void 0 ? t : Array.from(t);
}
function Dt(t, e) {
  const n = {}, l = {}, c = { $$scope: 1 };
  let i = t.length;
  for (; i--; ) {
    const a = t[i], r = e[i];
    if (r) {
      for (const s in a)
        s in r || (l[s] = 1);
      for (const s in r)
        c[s] || (n[s] = r[s], c[s] = 1);
      t[i] = r;
    } else
      for (const s in a)
        c[s] = 1;
  }
  for (const a in l)
    a in n || (n[a] = void 0);
  return n;
}
function D(t) {
  t && t.c();
}
function I(t, e, n) {
  const { fragment: l, after_update: c } = t.$$;
  l && l.m(e, n), he(() => {
    const i = t.$$.on_mount.map(xe).filter(ce);
    t.$$.on_destroy ? t.$$.on_destroy.push(...i) : Q(i), t.$$.on_mount = [];
  }), c.forEach(he);
}
function U(t, e) {
  const n = t.$$;
  n.fragment !== null && (Ot(n.after_update), Q(n.on_destroy), n.fragment && n.fragment.d(e), n.on_destroy = n.fragment = null, n.ctx = []);
}
function Ht(t, e) {
  t.$$.dirty[0] === -1 && (te.push(t), It(), t.$$.dirty.fill(0)), t.$$.dirty[e / 31 | 0] |= 1 << e % 31;
}
function F(t, e, n, l, c, i, a = null, r = [-1]) {
  const s = fe;
  ue(t);
  const g = t.$$ = {
    fragment: null,
    ctx: [],
    // state
    props: i,
    update: O,
    not_equal: c,
    bound: Ce(),
    // lifecycle
    on_mount: [],
    on_destroy: [],
    on_disconnect: [],
    before_update: [],
    after_update: [],
    context: new Map(e.context || (s ? s.$$.context : [])),
    // everything else
    callbacks: Ce(),
    dirty: r,
    skip_bound: !1,
    root: e.target || s.$$.root
  };
  a && a(g.root);
  let m = !1;
  if (g.ctx = n ? n(t, e.props || {}, (d, h, ...o) => {
    const u = o.length ? o[0] : h;
    return g.ctx && c(g.ctx[d], g.ctx[d] = u) && (!g.skip_bound && g.bound[d] && g.bound[d](u), m && Ht(t, d)), h;
  }) : [], g.update(), m = !0, Q(g.before_update), g.fragment = l ? l(g.ctx) : !1, e.target) {
    if (e.hydrate) {
      const d = Et(e.target);
      g.fragment && g.fragment.l(d), d.forEach(k);
    } else
      g.fragment && g.fragment.c();
    e.intro && v(t.$$.fragment), I(t, e.target, e.anchor), rt();
  }
  ue(s);
}
class Y {
  constructor() {
    /**
     * ### PRIVATE API
     *
     * Do not use, may change at any time
     *
     * @type {any}
     */
    j(this, "$$");
    /**
     * ### PRIVATE API
     *
     * Do not use, may change at any time
     *
     * @type {any}
     */
    j(this, "$$set");
  }
  /** @returns {void} */
  $destroy() {
    U(this, 1), this.$destroy = O;
  }
  /**
   * @template {Extract<keyof Events, string>} K
   * @param {K} type
   * @param {((e: Events[K]) => void) | null | undefined} callback
   * @returns {() => void}
   */
  $on(e, n) {
    if (!ce(n))
      return O;
    const l = this.$$.callbacks[e] || (this.$$.callbacks[e] = []);
    return l.push(n), () => {
      const c = l.indexOf(n);
      c !== -1 && l.splice(c, 1);
    };
  }
  /**
   * @param {Partial<Props>} props
   * @returns {void}
   */
  $set(e) {
    this.$$set && !ft(e) && (this.$$.skip_bound = !0, this.$$set(e), this.$$.skip_bound = !1);
  }
}
const Gt = "4";
typeof window < "u" && (window.__svelte || (window.__svelte = { v: /* @__PURE__ */ new Set() })).v.add(Gt);
var f = /* @__PURE__ */ ((t) => (t.English = "en", t.Czech = "cs", t.Deutsch = "de", t.Spanish = "es", t.SpanishMexican = "es-mx", t.French = "fr", t.Italian = "it", t.Japanese = "ja", t.Korean = "ko", t.Polish = "pl", t.Portuguese = "pt-br", t.Russian = "ru", t.Thai = "th", t.Turkish = "tr", t.Chinese = "zh-cn", t.ChineseSingaporean = "zh-sg", t.ChineseTaiwanese = "zh-tw", t.Dutch = "nl", t.Ukrainian = "uk", t))(f || {}), y = /* @__PURE__ */ ((t) => (t.EU = "eu", t.SG = "sg", t.US = "us", t.CN360 = "cn360", t))(y || {}), p = /* @__PURE__ */ ((t) => (t.PRIVACY_POLICY = "PRIVACY_POLICY", t.EULA = "EULA", t.PARTNERS = "PARTNERS", t.COOKIE_SETTINGS = "COOKIE_SETTINGS", t.PARENT_PORTAL = "PARENT_PORTAL", t.IMPRESSUM = "IMPRESSUM", t.JA_LEGAL = "JA_LEGAL", t.JA_TRANSACTION_LAW = "JA_TRANSACTION_LAW", t.DSA_DISCALMER_LOCALIZED = "DSA_DISCALMER_LOCALIZED", t.KO_PRIVACY = "KO_PRIVACY", t.KO_EULA = "KO_EULA", t.CN360_PRIVACY = "CN360_PRIVACY", t.CN360_EULA = "CN360_EULA", t))(p || {});
const $t = {
  src: new URL("" + new URL("images/logo-wg.svg", import.meta.url).href, import.meta.url).href,
  url: "https://wargaming.net"
}, Kt = {
  src: new URL("" + new URL("images/logo-wg.svg", import.meta.url).href, import.meta.url).href,
  url: "https://wg.360.cn/index.html"
}, Bt = {
  src: new URL("" + new URL("images/logo-360.png", import.meta.url).href, import.meta.url).href,
  url: "https://wg.360.cn/index.html"
}, Ft = {
  src: new URL("" + new URL("images/rating-eu.svg", import.meta.url).href, import.meta.url).href,
  url: "http://www.pegi.info/"
}, Yt = {
  src: new URL("" + new URL("images/rating-esrb.svg", import.meta.url).href, import.meta.url).href,
  url: "http://www.esrb.org/"
}, jt = {
  src: new URL("" + new URL("images/rating-ko.svg", import.meta.url).href, import.meta.url).href,
  url: "https://www.grac.or.kr/"
}, Ve = {
  src: new URL("" + new URL("images/rating-pt-br.png", import.meta.url).href, import.meta.url).href,
  url: "http://culturadigital.br/"
}, Jt = {
  src: new URL("" + new URL("images/rating-usk.svg", import.meta.url).href, import.meta.url).href,
  url: "https://usk.de/"
}, Me = {
  src: new URL("" + new URL("images/rating-tw.svg", import.meta.url).href, import.meta.url).href,
  url: ""
};
function zt({
  realm: t,
  language: e
}) {
  const n = t === y.CN360 ? [Kt, Bt] : [$t];
  return t === y.EU && e === "de" ? n.push(Jt) : t === y.EU && n.push(Ft), t === y.US && e === "pt-br" ? n.push(Ve) : t === y.US && e === "zh-tw" ? n.push(Me) : t === y.US && n.push(Yt), t === y.SG && e === "ko" ? n.push(jt) : t === y.SG && e === "pt-br" ? n.push(Ve) : t === y.SG && e === "zh-tw" && n.push(Me), n;
}
class Wt {
  constructor() {
    j(this, "_catalog");
    this._catalog = {};
  }
  set catalog(e) {
    this._catalog = e;
  }
  get catalog() {
    return { ...this._catalog };
  }
}
const ge = new Wt();
function qt() {
  try {
    const t = !!new URL(window.location.href).searchParams.get(
      "debug"
    ), e = !!localStorage.getItem("debug");
    return t || e;
  } catch {
    return !1;
  }
}
function G(t) {
  return qt() && !ge.catalog[t] && console.warn(`[debug] missing locale key :${t}`), ge.catalog[t] ?? t;
}
const Qt = `<p>Wargaming Group Limited
105, Agion Omologiton Avenue, Nicosia 1080, Cyprus
사업자등록번호 : 172-80-00777
워게이밍 유한회사 대표: 룽 라자 술라이만 아르비손
주소: 서울시 강남구 테헤란로 110, 캠브리지강남빌딩 11층
전화: 070-4355-3075, 이메일: <a href="mailto:support_kr@wargaming.net">support_kr@wargaming.net</a>
사업자등록번호 : 120-87-86583
통신판매업신고번호: 제2012-서울강남-02346호
<a href="http://www.ftc.go.kr/www/bizCommView.do?key=232&apv_perm_no=2012322016230202346&pageUnit=10&searchCnd=bup_nm&searchKrwd=워게이밍&pageIndex=1">사업자정보확인</a></p>`, Xt = `Copyright 2024 世界星辉 版权所有 北京世界星辉科技有限责任公司 趣游时代(北京)科技有限公司 北京市朝阳区酒仙桥路甲10号3号楼15层17层1769
<a href="https://p3.ssl.qhimg.com/t110b9a9301a224d9c3b81cef05.png">京ICP证140771号</a> | <a href="https://beian.miit.gov.cn/">京ICP备11014623号-26</a> | <a href="https://p5.ssl.qhimg.com/d/inn/1c8e56114591/sjxh.jpg">京网文〔2023〕1374-042 号</a>
公安备案号11010502047937号 | ISBN978-7-89988-420-1 | 新广出审【2015】1023号 | <a href="https://kf.wows.360.cn/">客服热线0536-3565277</a>
抵制不良游戏 拒绝盗版游戏 注意自我保护 谨防受骗上当 适度游戏益脑 沉迷游戏伤身 合理安排时间 享受健康生活

本产品在全球范围内并非由联邦、州和/或主权政府的任何分支机构或其任何军事分支机构或服务许可、背书和/或与之关联。与船舰有关的所有商标和商标权归各自的权利所有者所有。

所有引用的设计、模型、制造商和/或战舰以及战机的改造都为了符合历史事实，商标版权持有者从未出资或参与该项目。所有模型的技术参数均是根据20世纪战舰和战机的性能特点精确复制和重现的产物。与战舰和战机有关的所有商标和权利皆为相关持有人独占的资产。`;
function xt({
  realm: t,
  language: e
}) {
  const n = G("Wargaming.net All rights reserved."), l = G(
    "<p>This product is not licensed, endorsed, and/or affiliated with any branch of Federal, State, and/or sovereign government, or any military branch or service thereof, throughout the world. All trademarks and trademark rights pertaining to warships are proprietary to the respective rights holders.</p><p>All references to design, models, manufacturers and/or modifications of warships and warplanes are used to comply with historic facts, and do not involve any funding or participation of trademark rights holders in the project. Technical characteristics of all models are accurately reproduced, according to performance characteristics of the warships and warplanes of the 20th century. All trademarks and rights related to the warships and warplanes are the sole and exclusive properties of the relevant holders.</p>"
  );
  return t === y.SG && e === "ko" ? {
    legalText: Qt + l,
    copyrightText: n
  } : t === y.CN360 ? {
    legalText: Xt,
    copyrightText: n + "V{version}版本<a href='https://wg.360.cn/610636235/610636240/211088055.html'>隐私协议</a><a href='https://wg.360.cn/610636235/610636240/610636283.html'>用户权限</a>"
  } : {
    legalText: l,
    copyrightText: n
  };
}
const De = {
  [y.EU]: "eu",
  [y.SG]: "asia",
  [y.US]: "na",
  [y.CN360]: ""
}, en = {
  [y.EU]: [
    f.SpanishMexican,
    f.Japanese,
    f.Korean,
    f.Portuguese,
    f.Russian,
    f.Thai,
    f.ChineseSingaporean,
    f.ChineseTaiwanese
  ],
  [y.US]: [
    f.Czech,
    f.French,
    f.Italian,
    f.Japanese,
    f.Korean,
    f.Polish,
    f.Russian,
    f.Thai,
    f.ChineseSingaporean,
    f.ChineseTaiwanese
  ],
  [y.SG]: [
    f.Czech,
    f.Deutsch,
    f.SpanishMexican,
    f.French,
    f.Italian,
    f.Polish,
    f.Russian
  ]
};
function tn({
  realm: t,
  language: e
}) {
  const n = en[t];
  return n != null && n.includes(e) ? f.English : e;
}
function nn({ realm: t, language: e }) {
  switch (t) {
    case y.US:
    case y.EU:
    case y.SG:
      return tn({ realm: t, language: e });
    default:
      return f.English;
  }
}
function ln({
  realm: t,
  language: e
}) {
  const n = nn({ realm: t, language: e });
  return {
    [p.PRIVACY_POLICY]: {
      text: G("Privacy Policy"),
      url: `https://legal.${De[t]}.wargaming.net/${n}/Privacy-Policy`,
      className: e === f.Korean ? "active" : void 0
    },
    [p.EULA]: {
      text: G("EULA"),
      url: `http://legal.${De[t]}.wargaming.net/${n}/EULA`
    },
    [p.IMPRESSUM]: {
      text: G("Impressum"),
      url: `https://legal.wargaming.net/${n}/user-documents/other/impressum`
    },
    [p.PARTNERS]: {
      text: G("Partners"),
      url: "http://wargaming.com/partners/"
    },
    [p.COOKIE_SETTINGS]: {
      url: "#",
      text: "",
      id: "ot-sdk-btn",
      className: "ot-sdk-show-settings"
    },
    [p.PARENT_PORTAL]: {
      text: G("Parental Portal"),
      url: "https://eu.wargaming.net/family/login"
    },
    [p.JA_LEGAL]: {
      text: "資金決済法に基づく表示",
      url: "https://legal.asia.wargaming.net/ja/lsf/"
    },
    [p.JA_TRANSACTION_LAW]: {
      text: "特定商取引法に基づく表記",
      url: "https://legal.asia.wargaming.net/ja/specified-commercial-transaction-law/"
    },
    [p.DSA_DISCALMER_LOCALIZED]: {
      text: G("Report Content/Request Data"),
      url: "https://eu.wargaming.net/support/en/products/wgc/help/36122/"
    },
    [p.KO_PRIVACY]: {
      url: "http://legal.asia.wargaming.net/ko/privacy-policy-ko/",
      text: "개인정보처리방침",
      className: "active"
    },
    [p.KO_EULA]: {
      url: "http://legal.asia.wargaming.net/ko/eula-ko/",
      text: "최종 이용자 라이선스 계약"
    },
    [p.CN360_PRIVACY]: {
      url: "https://wg.360.cn/kf/legal/Privacy-Policy",
      text: "隐私政策"
    },
    [p.CN360_EULA]: {
      url: "https://wg.360.cn/kf/legal/EULA",
      text: "最终用户许可协议"
    }
  };
}
function oe(t) {
  return t.filter((e) => !!e);
}
const cn = ["fr", "de"];
function an({
  realm: t,
  language: e,
  linksConfig: n
}) {
  if (n = n || ln({ realm: t, language: e }), t === y.EU || t === y.US) {
    const l = [
      n[p.EULA],
      n[p.PRIVACY_POLICY],
      n[p.COOKIE_SETTINGS]
    ];
    return t === y.EU && (l.push(n[p.PARENT_PORTAL]), cn.includes(e) && l.splice(1, 0, n[p.IMPRESSUM])), l.push(n[p.DSA_DISCALMER_LOCALIZED], n[p.PARTNERS]), e === f.Japanese && l.push(n[p.JA_LEGAL], n[p.JA_TRANSACTION_LAW]), oe(l);
  }
  if (t === y.SG && e === f.Korean)
    return oe([
      n[p.KO_EULA],
      n[p.KO_PRIVACY],
      n[p.COOKIE_SETTINGS],
      n[p.PARTNERS]
    ]);
  if (t === y.SG) {
    const l = [
      n[p.EULA],
      n[p.PRIVACY_POLICY],
      n[p.COOKIE_SETTINGS],
      n[p.PARTNERS]
    ];
    return e === f.Japanese && l.push(n[p.JA_LEGAL], n[p.JA_TRANSACTION_LAW]), oe(l);
  }
  return t === y.CN360 ? oe([
    n[p.CN360_EULA],
    n[p.CN360_PRIVACY],
    n[p.PARTNERS]
  ]) : oe([
    n[p.EULA],
    n[p.PRIVACY_POLICY],
    n[p.COOKIE_SETTINGS],
    n[p.PARTNERS]
  ]);
}
function rn(t) {
  const e = (n) => {
    t.contains(n.target) || t.dispatchEvent(new CustomEvent("outclick"));
  };
  return document.addEventListener("click", e, !0), {
    destroy() {
      document.removeEventListener("click", e, !0);
    }
  };
}
function sn(t) {
  let e, n;
  return {
    c() {
      e = x("svg"), n = x("path"), _(n, "fill", "#fff"), _(n, "d", "M12.7 24c-.2-.1-.3-.2-.2-.3v-.1l.4.1.3.2h.2-.2l-.3.1h-.2Zm-.5-.4h-.1l-.2-.1v-.1c-.2 0-.3-.3-.4-.6l-.2-.3c-.2 0-.2 0 0-.1V21.8l-.2-.2c-.2-.1-.2-.2-.2-.4V20.6l-.1-.8-.1-1.7v-.4c-.1-.3-.4-.5-.8-.7l-.4-.4-.3-.4-.2-.4-.3-.6-.1-.2v-.3c.2-.2.2-.2 0-.2-.1 0 0-.3.3-.7.3-.3.3-.6.3-.8v-.2H9V12.4l-.4.1c0 .1 0 .1-.2 0h-.2l-.2-.2-.3-.2v-.1l-.1-.2-.1-.2s0-.1-.1 0l-.4-.1a.8.8 0 0 1-.3-.2l-.2-.2H6l-.6-.2a3 3 0 0 1-.6-.4c-.2-.1-.2-.2-.1-.3v-.4l-.3-.3-.2-.2-.1-.3-.2-.5-.1-.2h-.2l.1.5.2.5v.3c.2.2.1.2 0 0l-.2-.2v-.2c-.2-.1-.2-.2-.2-.3v-.3l-.1-.3c0-.2 0-.4-.2-.5-.1 0-.2 0-.2-.2v-.5L3 7v-.2l.1-.1.2-.3.2-.3.3-.4c0-.2.1-.3.2-.3 0 .2.1.2.2 0l.1-.2-.2-.3c-.2-.1-.2-.2-.1-.2v-.2l.1-.3V4c0-.2 0-.3-.2-.4l-.3-.1-.2-.1-.4-.1c-.3 0-.3-.1-.4 0H2l-.4.2-.5.2H1l-.9.4.2-.1.7-.4H.6l-.1-.1c.2-.1.3-.2.2-.4 0 0 .2-.2.6-.2l.4-.2c.2 0 .2-.2 0-.1h-.3c-.2 0-.2 0-.1-.1l.5-.1h.3l.1-.1v-.1L2 2l.3-.1.4-.1.7-.2h.9a14.4 14.4 0 0 0 1.1.2H7l.2-.1h.5l.5.1.3.1v.1h.3l.3.1.1.2v-.1l.4-.2h1c.1.2.1.2.2.1l.3-.1c.2 0 .2-.2.1-.3l.2-.1.2-.1v.1c0 .1 0 .3.1.2h.2v.2c-.2.2.1.1.4-.1l.4-.1-.1.2c-.2.2-.3.3-.5.3a1 1 0 0 0-.4 0h-.2c-.2 0-.2 0-.1.1v.1h-.1l-.4.1-.1.1-.3.2c-.5.2-.9.5-.7.6v.2l.2.1.4.1.4.2c.1 0 .1 0 0 .2v.4h.2s.2 0 .3-.2c0-.2.1-.3.3-.4.3-.2.5-.3.4-.5l.1-.2.2-.3c.1-.2.2-.2.5-.2.2 0 .5.2.5.3V3.6l.1.1h.1l.3-.2.2-.1V4l.1.2c.1.2.1.2 0 .2 0 0 0 .2.1.1h.3c.2.1 0 .3-.3.4-.3.2-.5.2-1 .2l-.7.2c-.2 0-.3.2-.3.2h.3l.4-.2c.1 0 .1 0 0 .1v.2c-.1 0-.1 0 0 .1 0 .2.2.2.4.2h.1-.1l-.3.2-.3.1h-.2l.2-.1c.2-.1.2-.2 0-.1-.1 0-.4 0-.6.2-.4.1-.4.2-.4.3l-.5.2-.3.2-.2.2-.2.2c0-.2-.1 0-.2.2 0 .2 0 .4-.3.5l-.8.5v1s0 .1-.1 0L8.8 9v-.2h-.2l-.3-.1H8l-.2.1H7l-.4.2-.2.2-.2.5-.1.4v.2c.1.5.3.6.7.6.2-.1.4-.2.4-.4l.2-.2h.4l-.2.7c-.2.3-.2.4 0 .3h.6v1.1l.2.2h.3c.2-.1.3-.1.4 0h.3l.1-.2.3-.2.2-.1c.1-.1.3-.2.2 0v.4l.1-.1V12h.5c0 .2.5.3.6.2.2 0 .8.3 1 .6l.5.3c.3-.1.7.2.8.5v.2l-.2.4-.1.2.2-.2c.2-.1.3-.2.4 0l-.2.2h.3c.2-.2.2-.2.4 0h.2c0 .2 0 .3.1.2h.4c.4 0 .4 0 .5.2l.4.2c.2 0 .3 0 .3.2s0 .4-.2.6l-.2.3-.2.3v.3c0 .5-.2 1.3-.4 1.5h-.5l-.2.2-.3.2c-.1 0-.1.1 0 .2l-.1.5-.1.2-.1.2-.2.4c-.2.3-.3.3-.6.2H13h.1l.2.3v.3l-.5.2c-.1 0-.2 0-.1.2v.2h-.2c-.2-.1-.3 0-.2.1l.2.2v.2l-.1.2c-.1.1-.1.1 0 .2v.2c.2 0 .2.2.1.4 0 .1-.1.3 0 .4l-.3.2Zm-3-17.3c.1-.3.3-.4.5-.4.1 0 .1 0 0 .1v.2H10c0-.2 0-.2.1-.1h.2c0-.2-.2-.4-.3-.3-.1 0-.3-.1-.2-.2l-.1-.2H8.9l-.1.2h-.1.6s.2.1.2 0l.1.1h-.1c-.2.1-.4.2-.5.5-.2.2-.2.3-.1.3H9l.2-.2Zm.7.2.2-.1h-.3c-.2 0-.2.2-.1.2h.2Zm.8-.3h-.3.3Zm3 17.3v-.1h.1-.2l.2-.1c.2 0 .2 0 .1.1 0 .1-.2.1-.2 0Zm34.1-1c-.1-.1.1-.3.7-.5l.6-.3.3-.2c.1.1 0 .2-.1.3l-.3.2H49l-.3.2c-.3.3-.6.4-.8.3Zm-2.8-.6v-.3s0-.1 0 0h.5l-.3.3c-.2.1-.2 0-.2 0Zm4.7-.3v-.1l.1-.2s0-.2.2-.2.2-.2.1-.5v-.1c.1 0 .2 0 .1.1l.1.3c.1.1.1.1.2 0V21.3l-.4.2-.4.2Zm-4.3-.5c-.1-.1-.1-.1-.2 0-.1 0-.3 0-.5-.2v-.5h-.2v-.1c.2-.2.2-.3 0-.1l-.3.1v-.1l-.3-.3h-.4a3 3 0 0 0-1 .2l-.5.1-.5.1c-.2.1-.3.1-.4 0-.2 0-.2 0-.1-.1l.1-.2v-1.5l.1-.2c0-.2 0-.2.5-.4l.6-.2c.2 0 .4-.1.5-.3 0-.2.1-.2.2-.2l.2-.2.1-.1.3-.2h.2l.3.1.3-.4.3-.1h.3c.3 0 .3 0 .2.2-.1.3-.1.4.3.6l.3.2.2-.2.2-.4.2-.6v.3l.2.3c.2 0 .2.4.2.6v.3c.2 0 .3.3.4.4l.2.5.2.2v.3l-.2.6-.5.5-.3.2-.1.2s-.2.1-.2.3l-.4.2h-.3l-.1.2-.1-.1Zm-20-.9V20l-.1-.3-.1-.2-.2-.2a.7.7 0 0 1-.1-.5c0-.4-.2-.8-.4-1.2l-.2-.4c0-.2 0-.5.3-.8v-1l-.2-.3c0-.2-.1-.3-.3-.4-.2-.3-.3-.4-.2-.6.2-.6 0-1-.4-.9h-.2l-.2-.3h-.4l-.5.2h-.9c-.2.2-.3.2-.4.1-.3 0-.7-.4-.8-.7l-.5-.6c-.1-.1-.1-.2 0-.2v-.2c-.2-.1-.2-.2 0-.2v-1l.1-.4.2-.4.5-.5.4-.4.3-.6.3-.2c.1-.2.1-.2.2-.1h.7c.3-.2.6-.3 1-.2h.5c.2-.2.3-.1.3 0V8l.3.1.5.2.2.2h.3c0 .1.1.1.2 0V8.3h.6c.3.2.9.3 1.1.3h.3c.3 0 .4 0 .4-.2V8l.1-.4v-.1c.1 0 .1 0 0 0 0-.2 0-.2-.3 0l-.3-.1H27l-.2-.4V7c-.2 0-.2 0-.1-.1h.1l.2-.1.3-.1.3-.1h.6c.4.2.6.2.8 0v-.2l-.4-.2-.3-.2V5.7l.1-.1c0-.1 0 0-.4 0l-.1.2h.1V6h-.3c-.1 0-.1-.1 0-.1l-.1-.1-.1-.1c-.1-.2-.5.2-.6.6v.3h.1l-.1.1h-.3l-.3.1H26v.6h-.2v-.2c.2 0 .2-.1 0-.1s-.3-.2-.3-.4-.2-.3-.3-.4l-.3-.1-.2-.2h-.2c0-.1 0-.2-.1-.1 0 .2.4.6.7.8l.1.1-.2.1V7.2v-.1c0-.2-.3-.5-.5-.5l-.5-.4c0-.2-.1-.2-.3 0h-.5c-.2 0-.3 0-.3.2v.1l-.2.1-.1.1-.2.4-.3.3h-.3l-.2.1c0 .1 0 .1-.1 0l-.4-.2v-.9c0-.1 0-.2.3-.2h.8v-.5c0-.1 0-.2-.2-.2s-.2-.2 0-.2h.3s.1-.1.1 0l.4-.3.1-.1.3-.2.4-.2c.2 0 .3-.2.3-.2l-.1-.3.1-.1.1-.1V4h.2c0-.1.1 0 .1 0s0 .2-.1.1H24v.1h.5c.1.1.2.1.4 0h.5c.2 0 .2-.1.2-.3 0-.2 0-.2.2-.2h.2v-.1l-.1-.2h.3c.2 0 .5 0 .4-.1h-.5l-.4-.1c-.2-.1-.2-.2 0-.4l.1-.4c0-.1-.2-.1-.3.1l-.3.2-.2.2v.2l.1.1v.3l-.2.2-.2.3h-.3v-.2l-.2-.3h-.5c-.1 0-.3 0-.3-.2v-.2l.3-.3.7-.4s0-.2.2-.3l.2-.2h.1l.4-.2.6-.1c.4 0 .6 0 .8.2h.3l1 .3c0 .1-.3.2-.5.1H27l.2.2c0 .2.4.3.5.3.1 0 .1-.1 0-.2-.1 0 0 0 0 0l.3-.1.2-.1c.2 0 .3 0 .2-.1V2h.2v.1h.4l.6-.2h.7s0-.2-.1-.1c0 0-.3 0-.2-.1L31 2l.2-.1-.2-.1c-.3-.2-.3-.4 0-.5.2 0 .2 0 .5.3.3.4.3.4.2.5-.1.1-.1.2 0 .2l.3-.2c0-.2 0-.3-.2-.3l-.2-.3h.1c.2 0 .3 0 .6-.3h.3c.2 0 .3 0 .2-.2l.9-.2h.3l.1-.2h-.4l-.4-.1c-.8 0-.8 0-.7-.2h.7l.1.1h.2l.6.2h.3c.1.1.2.2.5.2h.5l.1.1-.2.2c-.3.1-.2.2.1.1h1.6l.8.1a242.5 242.5 0 0 1 .7.3h.7c.1-.1.1-.2 0-.2h1.3c.2.2.3.2.8.2h.7c.1.1.3.2.7.2h.7c.2.1.2 0 .1 0h.3a6.8 6.8 0 0 1 1.6.2l.5.2h.3l.4.2.2.1h-.6v-.1H46c-.2-.1-.3 0-.2 0 0 .1 0 .1-.1 0-.2 0-.2.1.2.3l.4.1-.2.1-.4.2c-.1.1-.1.2-.2.1H45l-.2.1c0 .1 0 .3.3.4l.2.2.1.2V4.8h-.3c0-.2-.2-.3-.3-.3l-.3-.4c-.2-.2-.2-.2-.1-.3v-.2l.1-.2V3l-.3.1c0 .1 0 .2-.2 0h-.5v.4H42L42 4l-.1.2v.2h.6l.5.5.2.2c.2 0 .2.7 0 1 0 .3-.1.4-.3.3h-.1l-.1.1v.3l-.2.2s0 .2.2.3l.4.3v.2H43l-.1.2-.1-.3-.4-.4h-.1c0-.1 0-.2-.2-.3h-.2c-.2.1-.2.1-.2 0l-.2-.2-.2.1-.2.2v.1l.2.2h.7l-.1.1-.3.3V8l.3.2.2.2c.1.1.2.2 0 .3h.1c.2 0 .2.1 0 .6-.1.5-.2.7-.6.8h-.4l-.3.3-.1.1v-.1c-.1-.1-.2-.2-.4 0-.2 0-.3 0-.3.2 0 .1 0 .3.3.5.2.1.4.5.4.7 0 .2 0 .4-.2.5l-.2.1-.2.2V12.2H39.8l-.6-.5V12.7l.3.3c.3.2.3.2.4.5v.4h-.2l-.4-.8c0-.1 0-.2-.2-.3-.2-.1-.2-.1-.2-.3v-.7l-.2-.4c0-.3 0-.3-.2-.2l-.2.1-.1-.2-.3-.6c-.1 0-.2 0-.2-.2l-.3-.2-.3.1c-.2 0-.3.1-.3.2l-.1.2-.2.2h-.1l-.2.2-.2.3c-.2 0-.2.1-.2.2 0 .4 0 .8-.2 1-.1.2-.1.2-.3.1v-.1l-.3-.5c-.5-1.1-.6-1.3-.5-1.5l-.1-.3c0 .2-.3.3-.5.1v-.1c.1 0 .1-.2 0-.2h-.2l-.1-.1v-.1l-.5-.2h-1l-.3-.2h-.3l-.4-.1-.4-.3c0-.2-.2-.3-.3-.3l-.1.2V9c.2.1.2.3.3.4 0 .1.1.2.2 0l.1.2s.2.2.3.1c0 0 .2 0 .3-.2.1-.1.2-.1.2 0l.1.2.5.4-.1.1-.2.3c-.1.2-.4.5-.6.5 0 0-.3 0-.3.2l-.2.2-1 .4c-.2 0-.2 0-.2-.2l-.2-.3-.1-.4-.1-.1s0-.2-.2-.3a.9.9 0 0 1-.2-.3l-.2-.4c-.3-.4-.5-.6-.5-.8 0-.2-.2-.2-.2 0l-.1-.1c-.3-.3-.3-.2 0 .2a9.7 9.7 0 0 1 .5 1l.1.2c0 .2 0 .3.2.5l.2.3s0 .2.3.3c.2.2.4.4.4.6l.2.2h.5l.5-.2h.1v.1l-.3.8c-.3.6-.3.6-.6.8l-.4.4-.3.4c-.5.4-.5.8-.2 1.4V16.8c0 .2-.1.3-.4.4l-.2.1-.2.3a1 1 0 0 0-.2.2v.2c.2.3.1.5-.2.6l-.2.4v.2l-.2.2c-.2.2-.6.7-.9.8H26c-.3.2-.3.2-.4 0Zm5.4-12.7c.1 0 .2 0 .2-.2l-.1-.3-.1-.1v-.1h.2l-.1-.2c-.1-.1-.1-.2-.2-.1l-.2-.1c-.2-.1-.3-.3-.2-.4 0 0 .2-.1.2 0 .1 0 .2 0 0-.2-.1-.3-.4-.2-.7 0-.2.2-.2.3-.1.4l.2.3c.2.2.3.3.3.6v.2l.2.1c.2 0 .3.2.3.2l.1-.1Zm-1 11.2c-.2-.1-.2-.1-.3-.4l.2-.4v-.4c0-.3 0-.5.3-.5l.6-.5v-.2.1c.2.3.2.4 0 1l-.3.7c0 .4-.1.5-.3.6h-.3Zm20-.7-.2-.4.1.1.3.3v.2l-.2-.2Zm-18.2 0v-.1Zm21.5-.2s.1 0 0 0Zm-21.2 0Zm20.1-.4c0-.1 0-.2.2-.1-.1.1-.1.1-.2 0Zm.3-.2s0-.1.1 0c0 0 .1 0 0 0h-.1Zm-2-.2c0-.1 0-.2.1 0 .1.1.1.1 0 .1Zm.2 0Zm3.4-.4c.1 0 .1 0 0 0Zm-24.1-.2Zm17.9-.3-.5-.3c-.1-.2-.3-.3-.4-.3 0 0-.2 0-.2.2H46c0-.1-.1-.2-.2-.1h-.2v-.1c.2-.1.2-.1.1-.3l-.4-.3-.4-.1c-.2 0-.2-.1-.1-.2l-.1-.2c-.2 0-.2 0-.1-.1h.2s.2 0 .2.2v.1c.1.2.2.2.2 0l.3-.1.2-.1.2.1.5.2.4.2c.3.2.5.4.4.5l.4.5c.3.2.3.2 0 .2Zm1.7 0V16h.1c0 .1 0 0 0 0Zm-6.8-.2h.1-.1Zm.7 0c0-.2.3-.3.4-.2.2 0 .2 0 0 0l-.2.1c-.3.2-.3.2-.2 0Zm5.9 0h.1-.1Zm.2 0v-.2.2Zm3.1 0h.1Zm-10.4-.2h.3H42Zm.6 0c0-.1 0-.1.2 0 .2 0 .2 0 0 0h-.2Zm6.1 0v-.1h.1v.1Zm.3 0c-.1-.2 0-.2 0 0h.1-.1Zm-7.7 0-.4-.2h-.3l-.5-.2h1.2l.1.2.3.1h-.4Zm7.4-.3s.1.1 0 .1Zm-.3 0v-.2c0-.1 0-.1 0 0v.1c.1 0 .1 0 0 .1Zm-.9-.1v-.1h.1l.3-.2h.1l-.2.2h-.3ZM40 15c-.2 0-.4-.4-.5-.6l-.3-.4-.2-.3-.2-.3-.2-.4.5.3.5.5c.2 0 .2.2.2.3l.1.1a128.2 128.2 0 0 0 .4.5c0 .2-.1.4-.3.3Zm-8.2 0Zm10.8 0V14.8c-.1-.1-.1-.1 0-.2v-.3c0-.2 0-.3.2-.3h.3l.3-.1h.1c0 .2-.2.2-.3.1-.3 0-.6.1-.4.3h.4c-.2.1-.2.2-.1.3V15l-.2-.2c0-.1 0-.1-.2 0v.4h-.1Zm5.6-.2-.2-.2c-.1 0-.2 0-.1-.1 0 0 .4.2.3.3Zm-6.4-.2h-.2l-.6-.1-.1-.6V14c0-.1 0-.1.1 0l.2-.1s0-.2.2-.2l.2-.2.2-.2.2-.2H42.3l.2.2-.1.1c-.2.2-.2.3 0 .5v.1l-.1.2-.4.6h-.1Zm2.3 0h.2c.1 0 .1 0 0 0h-.2Zm6.5-.5h.1Zm-6.6-.1v-.2l.1-.2v.2c0 .2 0 .3-.1.2ZM23.5 14Zm28.3-.1Zm-28-.4Zm19.6-.6-.2-.2H43c0-.1 0-.1.1 0 .1 0 .2 0 .3-.2v-.1l.3.4c0 .1 0 .1 0 0-.2 0-.3 0-.2.2l-.2-.1Zm-7.5 0v-.4c0-.1 0-.1.1 0 .1.2.2.3.1.4 0 0-.2.1-.2 0Zm9.1-.1v-.1h.1Zm6.4 0h.1Zm-9.2-.3.2-.2.1-.1v.2l-.3.1Zm.9 0v-.2.1Zm-31.3-.2v-.1h.2l-.1.1c-.1 0-.1 0 0 0Zm31.5 0V12s.1.2 0 .2ZM43 12l.1-.1v.1Zm.5 0v-.2l.1.1c.1.2 0 .1-.1 0Zm-.7-.2v-.2l.1.2Zm-32 0v-.1Zm-.2-.1Zm1.9 0v-.1Zm30.7 0-.1-.1c-.1 0-.2 0-.3-.2-.2-.2-.3-.3-.2-.4V11c0-.2.2-.2.3 0v.6h.3v.1c.2 0 .1.2 0 .1Zm-31-.3c.1-.1.1 0 .1 0Zm6.5-.2Zm-6.6-.1V11h.1Zm-.3-.2s.1 0 0 0Zm6.5 0Zm-6.4 0v-.1h.1Zm.2 0v-.1c.1 0 0 0 0 0Zm-2.8-.2c0-.1.1 0 .2 0s.1 0 0 0h-.2Zm1 0H10c-.1 0-.1 0 0 0 .2 0 .3-.1.2-.2h.7l-.5.2Zm.8 0h.2-.2Zm29.6 0c-.2-.2 0-.3.1-.3s.1 0 0 .1c0 .2 0 .2-.1.1Zm-29.2 0v-.1Zm-1.8-.3h-.2l-.1-.1-.2-.2c-.3-.2-.4-.2-.6-.1h-.2l.5-.2c.3 0 .4 0 .8.3l.3.2h-.3Zm.3-.4h.1-.1Zm32.5 0-.1-.2v-.2c.1-.2.2-.2.2 0 0 0 0 .4-.1.3ZM10.2 10h.2-.2Zm-.8-.4c-.1 0 0-.2 0-.2v.2Zm.2-.3v-.1.1Zm-.3 0 .1-.1v.1Zm34.3-1h-.1c-.2-.2-.1-.3 0-.2l.2.3h-.1Zm-31.7-.2Zm31.9 0 .1-.1V8h-.1Zm.4-.2h-.7l.1-.2h.3l.3-.2c.3-.2.3-.3.2-.5v-.3c.2.1.4.3.3.4v.3c.1.1.1.2 0 .2 0 .1-.1.2-.3.2l-.1.1V8h-.1ZM27.6 8v-.2h.2s.1 0 0 0l-.2.1Zm-1.4-.2h.4c0 .1-.2.1-.4 0Zm-1.6-.4c-.2 0-.2 0 0 0 0-.1.2 0 .2 0 0 .1 0 .1-.2 0Zm-.8-.4v-.2l.1.2c0 .1 0 .2-.1 0Zm-1 0h.1c0 .1-.1 0 0 0Zm21.3-.4V6c0-.2 0-.2.1 0h.3c.3.1.3.2.2.2v.1h-.2l-.3.1c0 .1 0 .1 0 0Zm-20.3 0v-.1h.1v.1Zm20-.8-.1-.3c0-.2-.3-.4-.4-.6-.2-.1-.3-.3-.2-.3l.1.1.5.4c.2.2.3.3.1.3l.1.2.2.2h-.2ZM14 5.7v-.1Zm-.2-.2h-.1l.2-.3.4-.3v.3l.2.1v.2h-.7Zm-10-.3V5s.2 0 .3.2v.1l-.2-.1Zm18-.2h.2c.2-.1.1-.2 0-.2s-.2 0 0-.1v-.2h.2l-.1-.3h-.2V4s0-.3.2-.3v.1h.2l-.1.1-.1.1c.2.1.3.2.4.5l.2.1s.1 0 0 .1c0 0-.1.1 0 .2h-.3a16.5 16.5 0 0 0-.6.1Zm-.7-.2v-.2l.1-.1v-.2h.2c0-.1.3-.1.4 0l-.1.3-.2.1a5 5 0 0 0-.3.1Zm.8-.4ZM3.8 4.2V4s.1 0 0 0c0 .1 0 .1 0 0Zm0-.3v-.1c0 .1 0 .1 0 0ZM1 3.9l.3-.2v.1H1Zm24.2-.5h.1Zm-9-.2c-.2-.1-.3-.3-.2-.5v-.2c-.1-.1 0-.3.2-.4l.3-.2c0-.1 0-.3-.2-.4 0-.2-.1-.4-.3-.5l-.5-.1c-.4 0-.5 0-.5-.2V.6h.4l.7-.2c.4-.2.5-.2 1.5-.2h1c.3-.1.6-.2.7-.1h1.4l.4.1h.2l-.3.1c-.2 0-.5.3-.4.4l-.1.2-.2.1c0 .1-.3.3-.5.3s-.2 0 0 .1l.2.2h-.5c-.2.1-.1.2 0 .2h.3l-.4.1a4 4 0 0 1-.5.1c-.3 0-.4 0-.7.3l-.4.1c-.4.1-.6.2-.8.5-.2.3-.3.4-.5.4h-.2ZM13.6 3l-.3-.2c0-.1-.1-.1-.4 0h-.2c0-.1.1-.2.4-.2h.2c0-.1.3-.2.4-.1h.2c.1 0 .1 0 0-.1v-.1l-.2-.2-.3-.2c0-.1-.1-.1-.2 0h-.3a1 1 0 0 0-.4 0l-.3-.2s.3-.3.5-.3h.2-.1c-.2.2-.1.3 0 .1l.3-.1.4.1h.3l.2.1.3.2c.2 0 .2 0 .2.2v.2l.3.3c-.1.1-.2.1-.4 0h-.2v.4H14c-.2 0-.3 0-.1.1V3h-.3Zm8.4 0V3Zm-10-.1h-.2c-.2 0-.3 0-.2-.1.1-.2.2-.2.4-.1l.2.2h-.2Zm8.1 0-.1-.1h-.1c0-.1.4-.3.5-.2h.6v.1l-.7.2H20ZM9 2h-.3l-.2-.2H9l-.2-.1h-.1c.1 0 .1-.1 0-.2-.1 0-.1 0 0 0 .3-.2.5-.2.8-.1h.6s.2-.1.2 0v.1l-.2.1.2.1h.1l-.2.2h-.8L9 2Zm1.6 0v-.1h.3c-.2.2-.2.2-.3 0Zm11.3-.2Zm7.4-.1c-.2 0-.2 0-.1-.2l.1-.2.3-.2.4-.1h.6-.3c-.3.1-.5.2-.6.4-.2.1-.2.2 0 .3h-.4ZM8 1.6l.2-.3c.4-.2.6-.2 1-.1h.1l-.2.1-1 .3H8Zm3 0-.2-.2h-.1H11l.4-.2v.1c0 .2-.5.3-.5.2Zm.6-.2.5-.2-.2.2H11.6Zm1.3-.3h-.5l.1-.2h1.1l.2.1h-.2l-.2.2H13ZM24.6 1c-.2 0-.2-.1 0-.1h.1-.1c0-.1 0-.1 0 0h-.2L24 .5h.8c0-.2 0-.1.1 0l.1-.1h.1c0-.1 0-.1 0 0h.4c.3 0 .3 0 .1.1h-.5l.3.2c.1 0 .1 0 0 .1h-.2V.6H25V1l-.2.1h-.2ZM13.8 1h-.3L13 .7h.2c.3 0 .5-.1.3-.2.3 0 .3 0 .2-.1l.4-.1h.5V.3h-.8a20.7 20.7 0 0 1 2.3-.3h.2l-.4.2-1 .2-.3.2h-.3l-.3.2a21.9 21.9 0 0 1-.3 0ZM13 .5c-.2 0-.2 0 0-.1.1-.1.3-.2.4-.1.1 0 0 0 0 .1-.2.1-.3.1-.4 0Z"), _(n, "opacity", ".8"), _(e, "width", "54"), _(e, "height", "24");
    },
    m(l, c) {
      R(l, e, c), S(e, n);
    },
    p: O,
    i: O,
    o: O,
    d(l) {
      l && k(e);
    }
  };
}
class on extends Y {
  constructor(e) {
    super(), F(this, e, null, sn, K, {});
  }
}
function ke(t) {
  let e, n;
  const l = (
    /*#slots*/
    t[10].default
  ), c = ht(
    l,
    t,
    /*$$scope*/
    t[9],
    null
  );
  let i = [{ class: (
    /*className*/
    t[8]
  ) }], a = {};
  for (let r = 0; r < i.length; r += 1)
    a = Xe(a, i[r]);
  return {
    c() {
      e = N(
        /*tag*/
        t[0]
      ), c && c.c(), be(
        /*tag*/
        t[0]
      )(e, a), b(
        e,
        "wcf-main",
        /*main*/
        t[1]
      ), b(
        e,
        "wcf-main-gray",
        /*mainGray*/
        t[2]
      ), b(
        e,
        "wcf-secondary",
        /*secondary*/
        t[3]
      ), b(
        e,
        "wcf-secondary-roboto",
        /*secondaryRoboto*/
        t[4]
      ), b(
        e,
        "wcf-secondary-dropdown",
        /*secondaryDropdown*/
        t[5]
      ), b(
        e,
        "wcf-header",
        /*header*/
        t[6]
      ), b(
        e,
        "wcf-active",
        /*active*/
        t[7]
      );
    },
    m(r, s) {
      R(r, e, s), c && c.m(e, null), n = !0;
    },
    p(r, s) {
      c && c.p && (!n || s & /*$$scope*/
      512) && mt(
        c,
        l,
        r,
        /*$$scope*/
        r[9],
        n ? gt(
          l,
          /*$$scope*/
          r[9],
          s,
          null
        ) : dt(
          /*$$scope*/
          r[9]
        ),
        null
      ), be(
        /*tag*/
        r[0]
      )(e, a = Dt(i, [(!n || s & /*className*/
      256) && { class: (
        /*className*/
        r[8]
      ) }])), b(
        e,
        "wcf-main",
        /*main*/
        r[1]
      ), b(
        e,
        "wcf-main-gray",
        /*mainGray*/
        r[2]
      ), b(
        e,
        "wcf-secondary",
        /*secondary*/
        r[3]
      ), b(
        e,
        "wcf-secondary-roboto",
        /*secondaryRoboto*/
        r[4]
      ), b(
        e,
        "wcf-secondary-dropdown",
        /*secondaryDropdown*/
        r[5]
      ), b(
        e,
        "wcf-header",
        /*header*/
        r[6]
      ), b(
        e,
        "wcf-active",
        /*active*/
        r[7]
      );
    },
    i(r) {
      n || (v(c, r), n = !0);
    },
    o(r) {
      T(c, r), n = !1;
    },
    d(r) {
      r && k(e), c && c.d(r);
    }
  };
}
function un(t) {
  let e = (
    /*tag*/
    t[0]
  ), n, l, c = (
    /*tag*/
    t[0] && ke(t)
  );
  return {
    c() {
      c && c.c(), n = me();
    },
    m(i, a) {
      c && c.m(i, a), R(i, n, a), l = !0;
    },
    p(i, [a]) {
      /*tag*/
      i[0] ? e ? K(
        e,
        /*tag*/
        i[0]
      ) ? (c.d(1), c = ke(i), e = /*tag*/
      i[0], c.c(), c.m(n.parentNode, n)) : c.p(i, a) : (c = ke(i), e = /*tag*/
      i[0], c.c(), c.m(n.parentNode, n)) : e && (c.d(1), c = null, e = /*tag*/
      i[0]);
    },
    i(i) {
      l || (v(c, i), l = !0);
    },
    o(i) {
      T(c, i), l = !1;
    },
    d(i) {
      i && k(n), c && c.d(i);
    }
  };
}
function fn(t, e, n) {
  let { $$slots: l = {}, $$scope: c } = e, { tag: i = "div" } = e, { main: a = !1 } = e, { mainGray: r = !1 } = e, { secondary: s = !1 } = e, { secondaryRoboto: g = !1 } = e, { secondaryDropdown: m = !1 } = e, { header: d = !1 } = e, { active: h = !1 } = e, { class: o = "" } = e;
  return t.$$set = (u) => {
    "tag" in u && n(0, i = u.tag), "main" in u && n(1, a = u.main), "mainGray" in u && n(2, r = u.mainGray), "secondary" in u && n(3, s = u.secondary), "secondaryRoboto" in u && n(4, g = u.secondaryRoboto), "secondaryDropdown" in u && n(5, m = u.secondaryDropdown), "header" in u && n(6, d = u.header), "active" in u && n(7, h = u.active), "class" in u && n(8, o = u.class), "$$scope" in u && n(9, c = u.$$scope);
  }, [
    i,
    a,
    r,
    s,
    g,
    m,
    d,
    h,
    o,
    c,
    l
  ];
}
class q extends Y {
  constructor(e) {
    super(), F(this, e, fn, un, K, {
      tag: 0,
      main: 1,
      mainGray: 2,
      secondary: 3,
      secondaryRoboto: 4,
      secondaryDropdown: 5,
      header: 6,
      active: 7,
      class: 8
    });
  }
}
function hn(t) {
  let e, n;
  return {
    c() {
      e = x("svg"), n = x("path"), _(n, "fill", "#fff"), _(n, "d", "m8 8.6 3.4-3.2h.6l.6.6v.5l-4.3 4-.3.2-.3-.1-4.3-4a.4.4 0 0 1 0-.6l.6-.6h.6L8 8.6Z"), _(n, "opacity", ".8"), _(e, "width", "16"), _(e, "height", "16"), _(
        e,
        "class",
        /*className*/
        t[0]
      );
    },
    m(l, c) {
      R(l, e, c), S(e, n);
    },
    p(l, [c]) {
      c & /*className*/
      1 && _(
        e,
        "class",
        /*className*/
        l[0]
      );
    },
    i: O,
    o: O,
    d(l) {
      l && k(e);
    }
  };
}
function gn(t, e, n) {
  let { class: l = "" } = e;
  return t.$$set = (c) => {
    "class" in c && n(0, l = c.class);
  }, [l];
}
class st extends Y {
  constructor(e) {
    super(), F(this, e, gn, hn, K, { class: 0 });
  }
}
function He(t, { delay: e = 0, duration: n = 400, easing: l = Qe } = {}) {
  const c = +getComputedStyle(t).opacity;
  return {
    delay: e,
    duration: n,
    easing: l,
    css: (i) => `opacity: ${i * c}`
  };
}
function mn(t) {
  let e, n;
  return {
    c() {
      e = x("svg"), n = x("path"), _(n, "fill", "#fff"), _(n, "d", "m10.8 8.9-2 2L19 21 9 31.2l2 2L21 23 31.2 33l2-2L23 21 33 10.8l-2-2L21 19 10.8 9Z"), _(n, "opacity", ".8"), _(e, "width", "42"), _(e, "height", "42");
    },
    m(l, c) {
      R(l, e, c), S(e, n);
    },
    p: O,
    i: O,
    o: O,
    d(l) {
      l && k(e);
    }
  };
}
class dn extends Y {
  constructor(e) {
    super(), F(this, e, null, mn, K, {});
  }
}
function Ge(t, e, n) {
  const l = t.slice();
  return l[10] = e[n], l;
}
function $e(t, e, n) {
  const l = t.slice();
  return l[13] = e[n], l;
}
function _n(t) {
  let e = G("Select your region") + "", n;
  return {
    c() {
      n = $(e);
    },
    m(l, c) {
      R(l, n, c);
    },
    p: O,
    d(l) {
      l && k(n);
    }
  };
}
function pn(t) {
  let e = G("Selecting another region may affect for the website content") + "", n;
  return {
    c() {
      n = $(e);
    },
    m(l, c) {
      R(l, n, c);
    },
    p: O,
    d(l) {
      l && k(n);
    }
  };
}
function vn(t) {
  let e = (
    /*realmOption*/
    t[10].title + ""
  ), n;
  return {
    c() {
      n = $(e);
    },
    m(l, c) {
      R(l, n, c);
    },
    p(l, c) {
      c & /*realms*/
      4 && e !== (e = /*realmOption*/
      l[10].title + "") && Re(n, e);
    },
    d(l) {
      l && k(n);
    }
  };
}
function Ke(t) {
  let e, n, l = W(
    /*realmOption*/
    t[10].languages
  ), c = [];
  for (let a = 0; a < l.length; a += 1)
    c[a] = Be($e(t, l, a));
  const i = (a) => T(c[a], 1, 1, () => {
    c[a] = null;
  });
  return {
    c() {
      e = N("div");
      for (let a = 0; a < c.length; a += 1)
        c[a].c();
      _(e, "class", "wcf-realm-languages-options"), Pe(e, "grid-template-columns", "repeat(" + Math.ceil(
        /*realmOption*/
        t[10].languages.length / 6
      ) + ", 152px)");
    },
    m(a, r) {
      R(a, e, r);
      for (let s = 0; s < c.length; s += 1)
        c[s] && c[s].m(e, null);
      n = !0;
    },
    p(a, r) {
      if (r & /*realms, language, realm, handleChangeLanguage*/
      39) {
        l = W(
          /*realmOption*/
          a[10].languages
        );
        let s;
        for (s = 0; s < l.length; s += 1) {
          const g = $e(a, l, s);
          c[s] ? (c[s].p(g, r), v(c[s], 1)) : (c[s] = Be(g), c[s].c(), v(c[s], 1), c[s].m(e, null));
        }
        for (ae(), s = l.length; s < c.length; s += 1)
          i(s);
        ie();
      }
      (!n || r & /*realms*/
      4) && Pe(e, "grid-template-columns", "repeat(" + Math.ceil(
        /*realmOption*/
        a[10].languages.length / 6
      ) + ", 152px)");
    },
    i(a) {
      if (!n) {
        for (let r = 0; r < l.length; r += 1)
          v(c[r]);
        n = !0;
      }
    },
    o(a) {
      c = c.filter(Boolean);
      for (let r = 0; r < c.length; r += 1)
        T(c[r]);
      n = !1;
    },
    d(a) {
      a && k(e), ye(c, a);
    }
  };
}
function wn(t) {
  let e = (
    /*languageOption*/
    t[13].title + ""
  ), n;
  return {
    c() {
      n = $(e);
    },
    m(l, c) {
      R(l, n, c);
    },
    p(l, c) {
      c & /*realms*/
      4 && e !== (e = /*languageOption*/
      l[13].title + "") && Re(n, e);
    },
    d(l) {
      l && k(n);
    }
  };
}
function Be(t) {
  let e, n, l, c, i;
  n = new q({
    props: {
      main: !0,
      $$slots: { default: [wn] },
      $$scope: { ctx: t }
    }
  });
  function a() {
    return (
      /*click_handler_2*/
      t[8](
        /*realmOption*/
        t[10],
        /*languageOption*/
        t[13]
      )
    );
  }
  return {
    c() {
      e = N("a"), D(n.$$.fragment), _(e, "class", "wcf-language-option"), b(
        e,
        "active",
        /*languageOption*/
        t[13].value === /*language*/
        t[0] && /*realmOption*/
        t[10].value === /*realm*/
        t[1]
      );
    },
    m(r, s) {
      R(r, e, s), I(n, e, null), l = !0, c || (i = z(e, "click", pe(a)), c = !0);
    },
    p(r, s) {
      t = r;
      const g = {};
      s & /*$$scope, realms*/
      65540 && (g.$$scope = { dirty: s, ctx: t }), n.$set(g), (!l || s & /*realms, language, realm*/
      7) && b(
        e,
        "active",
        /*languageOption*/
        t[13].value === /*language*/
        t[0] && /*realmOption*/
        t[10].value === /*realm*/
        t[1]
      );
    },
    i(r) {
      l || (v(n.$$.fragment, r), l = !0);
    },
    o(r) {
      T(n.$$.fragment, r), l = !1;
    },
    d(r) {
      r && k(e), U(n), c = !1, i();
    }
  };
}
function Fe(t) {
  let e, n, l, c, i, a, r, s, g, m, d;
  n = new st({
    props: { class: "wcf-realm-option-icon" }
  }), a = new q({
    props: {
      main: !0,
      $$slots: { default: [vn] },
      $$scope: { ctx: t }
    }
  });
  function h() {
    return (
      /*click_handler_1*/
      t[7](
        /*realmOption*/
        t[10]
      )
    );
  }
  let o = (
    /*realmOption*/
    t[10].value === /*selectedRealmValue*/
    t[3] && Ke(t)
  );
  return {
    c() {
      e = N("a"), D(n.$$.fragment), l = M(), c = N("div"), i = M(), D(a.$$.fragment), r = M(), o && o.c(), s = me(), _(c, "class", "wcf-divider"), _(e, "class", "wcf-realm-option"), b(
        e,
        "active",
        /*realmOption*/
        t[10].value === /*selectedRealmValue*/
        t[3]
      );
    },
    m(u, L) {
      R(u, e, L), I(n, e, null), S(e, l), S(e, c), S(e, i), I(a, e, null), R(u, r, L), o && o.m(u, L), R(u, s, L), g = !0, m || (d = z(e, "click", pe(h)), m = !0);
    },
    p(u, L) {
      t = u;
      const C = {};
      L & /*$$scope, realms*/
      65540 && (C.$$scope = { dirty: L, ctx: t }), a.$set(C), (!g || L & /*realms, selectedRealmValue*/
      12) && b(
        e,
        "active",
        /*realmOption*/
        t[10].value === /*selectedRealmValue*/
        t[3]
      ), /*realmOption*/
      t[10].value === /*selectedRealmValue*/
      t[3] ? o ? (o.p(t, L), L & /*realms, selectedRealmValue*/
      12 && v(o, 1)) : (o = Ke(t), o.c(), v(o, 1), o.m(s.parentNode, s)) : o && (ae(), T(o, 1, 1, () => {
        o = null;
      }), ie());
    },
    i(u) {
      g || (v(n.$$.fragment, u), v(a.$$.fragment, u), v(o), g = !0);
    },
    o(u) {
      T(n.$$.fragment, u), T(a.$$.fragment, u), T(o), g = !1;
    },
    d(u) {
      u && (k(e), k(r), k(s)), U(n), U(a), o && o.d(u), m = !1, d();
    }
  };
}
function yn(t) {
  let e, n, l, c, i, a, r, s, g, m, d, h, o, u, L;
  n = new q({
    props: {
      tag: "div",
      header: !0,
      $$slots: { default: [_n] },
      $$scope: { ctx: t }
    }
  }), c = new q({
    props: {
      tag: "div",
      secondaryDropdown: !0,
      $$slots: { default: [pn] },
      $$scope: { ctx: t }
    }
  });
  let C = W(
    /*realms*/
    t[2]
  ), Z = [];
  for (let w = 0; w < C.length; w += 1)
    Z[w] = Fe(Ge(t, C, w));
  const B = (w) => T(Z[w], 1, 1, () => {
    Z[w] = null;
  });
  return d = new dn({}), {
    c() {
      e = N("div"), D(n.$$.fragment), l = M(), D(c.$$.fragment), i = M(), a = N("div");
      for (let w = 0; w < Z.length; w += 1)
        Z[w].c();
      r = M(), s = N("div"), g = M(), m = N("div"), D(d.$$.fragment), _(s, "class", "wcf-divider"), _(a, "class", "wcf-realm-options"), _(m, "class", "wcf-language-picker-dropdown-close"), _(e, "class", "wcf-language-picker-dropdown");
    },
    m(w, P) {
      R(w, e, P), I(n, e, null), S(e, l), I(c, e, null), S(e, i), S(e, a);
      for (let H = 0; H < Z.length; H += 1)
        Z[H] && Z[H].m(a, null);
      S(a, r), S(a, s), S(e, g), S(e, m), I(d, m, null), o = !0, u || (L = [
        z(m, "click", pe(
          /*click_handler_3*/
          t[9]
        )),
        z(e, "click", pe(
          /*click_handler*/
          t[6]
        ))
      ], u = !0);
    },
    p(w, [P]) {
      const H = {};
      P & /*$$scope*/
      65536 && (H.$$scope = { dirty: P, ctx: w }), n.$set(H);
      const X = {};
      if (P & /*$$scope*/
      65536 && (X.$$scope = { dirty: P, ctx: w }), c.$set(X), P & /*Math, realms, language, realm, handleChangeLanguage, selectedRealmValue*/
      47) {
        C = W(
          /*realms*/
          w[2]
        );
        let V;
        for (V = 0; V < C.length; V += 1) {
          const re = Ge(w, C, V);
          Z[V] ? (Z[V].p(re, P), v(Z[V], 1)) : (Z[V] = Fe(re), Z[V].c(), v(Z[V], 1), Z[V].m(a, r));
        }
        for (ae(), V = C.length; V < Z.length; V += 1)
          B(V);
        ie();
      }
    },
    i(w) {
      if (!o) {
        v(n.$$.fragment, w), v(c.$$.fragment, w);
        for (let P = 0; P < C.length; P += 1)
          v(Z[P]);
        v(d.$$.fragment, w), w && he(() => {
          o && (h || (h = Oe(e, He, { duration: 200 }, !0)), h.run(1));
        }), o = !0;
      }
    },
    o(w) {
      T(n.$$.fragment, w), T(c.$$.fragment, w), Z = Z.filter(Boolean);
      for (let P = 0; P < Z.length; P += 1)
        T(Z[P]);
      T(d.$$.fragment, w), w && (h || (h = Oe(e, He, { duration: 200 }, !1)), h.run(0)), o = !1;
    },
    d(w) {
      w && k(e), U(n), U(c), ye(Z, w), U(d), w && h && h.end(), u = !1, Q(L);
    }
  };
}
function Ln(t, e, n) {
  let { language: l = "" } = e, { realm: c = y.EU } = e, { realms: i = [] } = e;
  const a = it();
  function r(o, u) {
    a("language-change", { realm: o, language: u });
  }
  let s = c;
  function g(o) {
    Pt.call(this, t, o);
  }
  const m = (o) => n(3, s = o.value), d = (o, u) => r(o.value, u.value), h = () => a("close");
  return t.$$set = (o) => {
    "language" in o && n(0, l = o.language), "realm" in o && n(1, c = o.realm), "realms" in o && n(2, i = o.realms);
  }, [
    l,
    c,
    i,
    s,
    a,
    r,
    g,
    m,
    d,
    h
  ];
}
class An extends Y {
  constructor(e) {
    super(), F(this, e, Ln, yn, K, { language: 0, realm: 1, realms: 2 });
  }
}
function kn(t) {
  let e, n = (
    /*currentLanguageOption*/
    t[5].title + ""
  ), l, c;
  return {
    c() {
      e = $("("), l = $(n), c = $(")");
    },
    m(i, a) {
      R(i, e, a), R(i, l, a), R(i, c, a);
    },
    p: O,
    d(i) {
      i && (k(e), k(l), k(c));
    }
  };
}
function Zn(t) {
  let e = (
    /*currentRealmOption*/
    t[4].title + ""
  ), n, l, c, i = (
    /*currentLanguageOption*/
    t[5] && kn(t)
  );
  return {
    c() {
      n = $(e), l = M(), i && i.c(), c = me();
    },
    m(a, r) {
      R(a, n, r), R(a, l, r), i && i.m(a, r), R(a, c, r);
    },
    p(a, r) {
      /*currentLanguageOption*/
      a[5] && i.p(a, r);
    },
    d(a) {
      a && (k(n), k(l), k(c)), i && i.d(a);
    }
  };
}
function Ye(t) {
  let e, n;
  return e = new An({
    props: {
      realms: (
        /*realms*/
        t[0]
      ),
      realm: (
        /*realm*/
        t[1]
      ),
      language: (
        /*language*/
        t[2]
      )
    }
  }), e.$on(
    "language-change",
    /*language_change_handler*/
    t[9]
  ), e.$on(
    "close",
    /*handleDropdownClose*/
    t[8]
  ), {
    c() {
      D(e.$$.fragment);
    },
    m(l, c) {
      I(e, l, c), n = !0;
    },
    p(l, c) {
      const i = {};
      c & /*realms*/
      1 && (i.realms = /*realms*/
      l[0]), c & /*realm*/
      2 && (i.realm = /*realm*/
      l[1]), c & /*language*/
      4 && (i.language = /*language*/
      l[2]), e.$set(i);
    },
    i(l) {
      n || (v(e.$$.fragment, l), n = !0);
    },
    o(l) {
      T(e.$$.fragment, l), n = !1;
    },
    d(l) {
      U(e, l);
    }
  };
}
function En(t) {
  let e, n, l, c, i, a, r, s, g, m, d;
  n = new on({}), i = new q({
    props: {
      main: !0,
      $$slots: { default: [Zn] },
      $$scope: { ctx: t }
    }
  }), r = new st({
    props: { class: "wcf-language-picker-icon" }
  });
  let h = (
    /*isDropdownOpen*/
    t[3] && Ye(t)
  );
  return {
    c() {
      e = N("div"), D(n.$$.fragment), l = M(), c = N("a"), D(i.$$.fragment), a = M(), D(r.$$.fragment), s = M(), h && h.c(), _(c, "class", "wcf-language-picker-button"), _(e, "class", "wcf-language-picker"), b(
        e,
        "open",
        /*isDropdownOpen*/
        t[3]
      );
    },
    m(o, u) {
      R(o, e, u), I(n, e, null), S(e, l), S(e, c), I(i, c, null), S(c, a), I(r, c, null), S(e, s), h && h.m(e, null), g = !0, m || (d = [
        z(
          e,
          "click",
          /*handleToggleDropdown*/
          t[7]
        ),
        _t(rn.call(null, e)),
        z(
          e,
          "outclick",
          /*handleDropdownClose*/
          t[8]
        )
      ], m = !0);
    },
    p(o, [u]) {
      const L = {};
      u & /*$$scope*/
      1024 && (L.$$scope = { dirty: u, ctx: o }), i.$set(L), /*isDropdownOpen*/
      o[3] ? h ? (h.p(o, u), u & /*isDropdownOpen*/
      8 && v(h, 1)) : (h = Ye(o), h.c(), v(h, 1), h.m(e, null)) : h && (ae(), T(h, 1, 1, () => {
        h = null;
      }), ie()), (!g || u & /*isDropdownOpen*/
      8) && b(
        e,
        "open",
        /*isDropdownOpen*/
        o[3]
      );
    },
    i(o) {
      g || (v(n.$$.fragment, o), v(i.$$.fragment, o), v(r.$$.fragment, o), v(h), g = !0);
    },
    o(o) {
      T(n.$$.fragment, o), T(i.$$.fragment, o), T(r.$$.fragment, o), T(h), g = !1;
    },
    d(o) {
      o && k(e), U(n), U(i), U(r), h && h.d(), m = !1, Q(d);
    }
  };
}
function Rn(t, e, n) {
  let { realms: l = [] } = e, { realm: c } = e, { language: i } = e, a = l.find((o) => o.value === c), r = a == null ? void 0 : a.languages.find((o) => o.value == i);
  const s = it();
  let g = !1;
  function m() {
    n(3, g = !g);
  }
  function d() {
    n(3, g = !1);
  }
  const h = (o) => s("language-change", o.detail);
  return t.$$set = (o) => {
    "realms" in o && n(0, l = o.realms), "realm" in o && n(1, c = o.realm), "language" in o && n(2, i = o.language);
  }, t.$$.update = () => {
    t.$$.dirty & /*isDropdownOpen*/
    8 && s("open-change", g);
  }, [
    l,
    c,
    i,
    g,
    a,
    r,
    s,
    m,
    d,
    h
  ];
}
class Tn extends Y {
  constructor(e) {
    super(), F(this, e, Rn, En, K, { realms: 0, realm: 1, language: 2 });
  }
}
function je(t, e, n) {
  const l = t.slice();
  return l[2] = e[n], l;
}
function Je(t) {
  let e, n;
  return e = new q({
    props: {
      tag: "span",
      main: !0,
      $$slots: { default: [Cn] },
      $$scope: { ctx: t }
    }
  }), {
    c() {
      D(e.$$.fragment);
    },
    m(l, c) {
      I(e, l, c), n = !0;
    },
    p(l, c) {
      const i = {};
      c & /*$$scope, legalLinks*/
      33 && (i.$$scope = { dirty: c, ctx: l }), e.$set(i);
    },
    i(l) {
      n || (v(e.$$.fragment, l), n = !0);
    },
    o(l) {
      T(e.$$.fragment, l), n = !1;
    },
    d(l) {
      U(e, l);
    }
  };
}
function Cn(t) {
  let e = (
    /*link*/
    t[2].text + ""
  ), n;
  return {
    c() {
      n = $(e);
    },
    m(l, c) {
      R(l, n, c);
    },
    p(l, c) {
      c & /*legalLinks*/
      1 && e !== (e = /*link*/
      l[2].text + "") && Re(n, e);
    },
    d(l) {
      l && k(n);
    }
  };
}
function ze(t) {
  let e, n, l, c, i, a, r, s, g, m = (
    /*link*/
    t[2].text && Je(t)
  );
  return {
    c() {
      e = N("a"), m && m.c(), n = M(), _(e, "href", l = /*link*/
      t[2].url), _(e, "class", c = `wcf-legal-link${/*link*/
      t[2].className ? ` ${/*link*/
      t[2].className}` : ""}`), _(e, "id", i = /*link*/
      t[2].id), _(e, "target", a = /*link*/
      t[2].isNewTab ? "_blank" : "_self");
    },
    m(d, h) {
      R(d, e, h), m && m.m(e, null), S(e, n), r = !0, s || (g = z(e, "click", function() {
        ce(
          /*onClickByLink*/
          t[1]
        ) && t[1].apply(this, arguments);
      }), s = !0);
    },
    p(d, h) {
      t = d, /*link*/
      t[2].text ? m ? (m.p(t, h), h & /*legalLinks*/
      1 && v(m, 1)) : (m = Je(t), m.c(), v(m, 1), m.m(e, n)) : m && (ae(), T(m, 1, 1, () => {
        m = null;
      }), ie()), (!r || h & /*legalLinks*/
      1 && l !== (l = /*link*/
      t[2].url)) && _(e, "href", l), (!r || h & /*legalLinks*/
      1 && c !== (c = `wcf-legal-link${/*link*/
      t[2].className ? ` ${/*link*/
      t[2].className}` : ""}`)) && _(e, "class", c), (!r || h & /*legalLinks*/
      1 && i !== (i = /*link*/
      t[2].id)) && _(e, "id", i), (!r || h & /*legalLinks*/
      1 && a !== (a = /*link*/
      t[2].isNewTab ? "_blank" : "_self")) && _(e, "target", a);
    },
    i(d) {
      r || (v(m), r = !0);
    },
    o(d) {
      T(m), r = !1;
    },
    d(d) {
      d && k(e), m && m.d(), s = !1, g();
    }
  };
}
function Sn(t) {
  let e, n, l = W(
    /*legalLinks*/
    t[0]
  ), c = [];
  for (let a = 0; a < l.length; a += 1)
    c[a] = ze(je(t, l, a));
  const i = (a) => T(c[a], 1, 1, () => {
    c[a] = null;
  });
  return {
    c() {
      e = N("div");
      for (let a = 0; a < c.length; a += 1)
        c[a].c();
      _(e, "class", "wcf-legal-links");
    },
    m(a, r) {
      R(a, e, r);
      for (let s = 0; s < c.length; s += 1)
        c[s] && c[s].m(e, null);
      n = !0;
    },
    p(a, [r]) {
      if (r & /*legalLinks, onClickByLink*/
      3) {
        l = W(
          /*legalLinks*/
          a[0]
        );
        let s;
        for (s = 0; s < l.length; s += 1) {
          const g = je(a, l, s);
          c[s] ? (c[s].p(g, r), v(c[s], 1)) : (c[s] = ze(g), c[s].c(), v(c[s], 1), c[s].m(e, null));
        }
        for (ae(), s = l.length; s < c.length; s += 1)
          i(s);
        ie();
      }
    },
    i(a) {
      if (!n) {
        for (let r = 0; r < l.length; r += 1)
          v(c[r]);
        n = !0;
      }
    },
    o(a) {
      c = c.filter(Boolean);
      for (let r = 0; r < c.length; r += 1)
        T(c[r]);
      n = !1;
    },
    d(a) {
      a && k(e), ye(c, a);
    }
  };
}
function bn(t, e, n) {
  let { legalLinks: l = [] } = e, { onClickByLink: c = () => {
  } } = e;
  return t.$$set = (i) => {
    "legalLinks" in i && n(0, l = i.legalLinks), "onClickByLink" in i && n(1, c = i.onClickByLink);
  }, [l, c];
}
class Pn extends Y {
  constructor(e) {
    super(), F(this, e, bn, Sn, K, { legalLinks: 0, onClickByLink: 1 });
  }
}
function Nn(t) {
  let e, n = (/* @__PURE__ */ new Date()).getFullYear() + "", l, c, i, a;
  return {
    c() {
      e = $("© 2012 – "), l = $(n), c = M(), i = new at(!1), a = me(), i.a = a;
    },
    m(r, s) {
      R(r, e, s), R(r, l, s), R(r, c, s), i.m(
        /*copyrightText*/
        t[0],
        r,
        s
      ), R(r, a, s);
    },
    p(r, s) {
      s & /*copyrightText*/
      1 && i.p(
        /*copyrightText*/
        r[0]
      );
    },
    d(r) {
      r && (k(e), k(l), k(c), k(a), i.d());
    }
  };
}
function In(t) {
  let e, n;
  return e = new q({
    props: {
      mainGray: (
        /*realm*/
        t[1] !== y.CN360
      ),
      secondary: (
        /*realm*/
        t[1] === y.CN360
      ),
      class: "wcf-copyright",
      $$slots: { default: [Nn] },
      $$scope: { ctx: t }
    }
  }), {
    c() {
      D(e.$$.fragment);
    },
    m(l, c) {
      I(e, l, c), n = !0;
    },
    p(l, [c]) {
      const i = {};
      c & /*realm*/
      2 && (i.mainGray = /*realm*/
      l[1] !== y.CN360), c & /*realm*/
      2 && (i.secondary = /*realm*/
      l[1] === y.CN360), c & /*$$scope, copyrightText*/
      5 && (i.$$scope = { dirty: c, ctx: l }), e.$set(i);
    },
    i(l) {
      n || (v(e.$$.fragment, l), n = !0);
    },
    o(l) {
      T(e.$$.fragment, l), n = !1;
    },
    d(l) {
      U(e, l);
    }
  };
}
function Un(t, e, n) {
  let { copyrightText: l = "" } = e, { realm: c } = e;
  return t.$$set = (i) => {
    "copyrightText" in i && n(0, l = i.copyrightText), "realm" in i && n(1, c = i.realm);
  }, [l, c];
}
class On extends Y {
  constructor(e) {
    super(), F(this, e, Un, In, K, { copyrightText: 0, realm: 1 });
  }
}
function Vn(t) {
  let e, n;
  return {
    c() {
      e = new at(!1), n = me(), e.a = n;
    },
    m(l, c) {
      e.m(
        /*legalText*/
        t[0],
        l,
        c
      ), R(l, n, c);
    },
    p(l, c) {
      c & /*legalText*/
      1 && e.p(
        /*legalText*/
        l[0]
      );
    },
    d(l) {
      l && (k(n), e.d());
    }
  };
}
function Mn(t) {
  let e, n;
  return e = new q({
    props: {
      secondaryRoboto: !0,
      class: "wcf-legal-text",
      $$slots: { default: [Vn] },
      $$scope: { ctx: t }
    }
  }), {
    c() {
      D(e.$$.fragment);
    },
    m(l, c) {
      I(e, l, c), n = !0;
    },
    p(l, [c]) {
      const i = {};
      c & /*$$scope, legalText*/
      3 && (i.$$scope = { dirty: c, ctx: l }), e.$set(i);
    },
    i(l) {
      n || (v(e.$$.fragment, l), n = !0);
    },
    o(l) {
      T(e.$$.fragment, l), n = !1;
    },
    d(l) {
      U(e, l);
    }
  };
}
function Dn(t, e, n) {
  let { legalText: l = "" } = e;
  return t.$$set = (c) => {
    "legalText" in c && n(0, l = c.legalText);
  }, [l];
}
class Hn extends Y {
  constructor(e) {
    super(), F(this, e, Dn, Mn, K, { legalText: 0 });
  }
}
function We(t, e, n) {
  const l = t.slice();
  return l[2] = e[n], l;
}
function qe(t) {
  let e, n, l, c, i, a, r, s, g, m;
  return {
    c() {
      e = N("a"), n = N("img"), r = M(), Se(n.src, l = /*image*/
      t[2].src) || _(n, "src", l), _(n, "class", "wcf-image"), _(n, "width", c = /*image*/
      t[2].width), _(n, "height", i = /*image*/
      t[2].height), _(n, "alt", a = /*image*/
      t[2].alt), _(e, "href", s = /*image*/
      t[2].url), _(e, "target", "_blank"), _(e, "class", "wcf-logo-link"), b(e, "disabled", !/*image*/
      t[2].url);
    },
    m(d, h) {
      R(d, e, h), S(e, n), S(e, r), g || (m = z(e, "click", function() {
        ce(
          /*onClickByLink*/
          t[1]
        ) && t[1].apply(this, arguments);
      }), g = !0);
    },
    p(d, h) {
      t = d, h & /*logosAndRatings*/
      1 && !Se(n.src, l = /*image*/
      t[2].src) && _(n, "src", l), h & /*logosAndRatings*/
      1 && c !== (c = /*image*/
      t[2].width) && _(n, "width", c), h & /*logosAndRatings*/
      1 && i !== (i = /*image*/
      t[2].height) && _(n, "height", i), h & /*logosAndRatings*/
      1 && a !== (a = /*image*/
      t[2].alt) && _(n, "alt", a), h & /*logosAndRatings*/
      1 && s !== (s = /*image*/
      t[2].url) && _(e, "href", s), h & /*logosAndRatings*/
      1 && b(e, "disabled", !/*image*/
      t[2].url);
    },
    d(d) {
      d && k(e), g = !1, m();
    }
  };
}
function Gn(t) {
  let e, n = W(
    /*logosAndRatings*/
    t[0]
  ), l = [];
  for (let c = 0; c < n.length; c += 1)
    l[c] = qe(We(t, n, c));
  return {
    c() {
      e = N("div");
      for (let c = 0; c < l.length; c += 1)
        l[c].c();
      _(e, "class", "wcf-logos-ratings");
    },
    m(c, i) {
      R(c, e, i);
      for (let a = 0; a < l.length; a += 1)
        l[a] && l[a].m(e, null);
    },
    p(c, [i]) {
      if (i & /*logosAndRatings, onClickByLink*/
      3) {
        n = W(
          /*logosAndRatings*/
          c[0]
        );
        let a;
        for (a = 0; a < n.length; a += 1) {
          const r = We(c, n, a);
          l[a] ? l[a].p(r, i) : (l[a] = qe(r), l[a].c(), l[a].m(e, null));
        }
        for (; a < l.length; a += 1)
          l[a].d(1);
        l.length = n.length;
      }
    },
    i: O,
    o: O,
    d(c) {
      c && k(e), ye(l, c);
    }
  };
}
function $n(t, e, n) {
  let { logosAndRatings: l = [] } = e, { onClickByLink: c = () => {
  } } = e;
  return t.$$set = (i) => {
    "logosAndRatings" in i && n(0, l = i.logosAndRatings), "onClickByLink" in i && n(1, c = i.onClickByLink);
  }, [l, c];
}
class Kn extends Y {
  constructor(e) {
    super(), F(this, e, $n, Gn, K, { logosAndRatings: 0, onClickByLink: 1 });
  }
}
const Bn = {
  [f.English]: "English",
  [f.Czech]: "Čeština",
  [f.Deutsch]: "Deutsch",
  [f.Spanish]: "Español",
  [f.SpanishMexican]: "Español mexicano",
  [f.French]: "Français",
  [f.Italian]: "Italiano",
  [f.Japanese]: "日本語",
  [f.Korean]: "한국어",
  [f.Polish]: "Polski",
  [f.Portuguese]: "Português",
  [f.Russian]: "Русский",
  [f.Thai]: "ไทย",
  [f.Turkish]: "Türkçe",
  [f.ChineseSingaporean]: "简体中文",
  [f.ChineseTaiwanese]: "繁體中文",
  [f.Dutch]: "Nederlands",
  [f.Ukrainian]: "Українська"
}, E = Object.keys(
  f
).reduce(
  (t, e) => ({
    ...t,
    [f[e]]: {
      title: Bn[f[e]],
      value: f[e]
    }
  }),
  {}
);
function Fn() {
  const t = [
    E[f.Czech],
    E[f.Deutsch],
    E[f.English],
    E[f.SpanishMexican],
    E[f.French],
    E[f.Italian],
    E[f.Japanese],
    E[f.Korean],
    E[f.Dutch],
    E[f.Polish],
    E[f.Portuguese],
    E[f.Russian],
    E[f.Thai],
    E[f.ChineseSingaporean],
    E[f.ChineseTaiwanese],
    E[f.Ukrainian]
  ];
  return [
    {
      title: G("Europe"),
      value: y.EU,
      languages: [
        E[f.Czech],
        E[f.Deutsch],
        E[f.English],
        E[f.Spanish],
        E[f.SpanishMexican],
        E[f.French],
        E[f.Italian],
        E[f.Dutch],
        E[f.Japanese],
        E[f.Korean],
        E[f.Polish],
        E[f.Portuguese],
        E[f.Russian],
        E[f.Thai],
        E[f.Turkish],
        E[f.ChineseSingaporean],
        E[f.ChineseTaiwanese],
        E[f.Ukrainian]
      ]
    },
    {
      title: G("North America"),
      value: y.US,
      languages: t
    },
    {
      title: G("Asia"),
      value: y.SG,
      languages: t
    }
  ];
}
function Yn(t) {
  let e, n;
  return e = new Tn({
    props: {
      realms: (
        /*realms*/
        t[2]
      ),
      realm: (
        /*realm*/
        t[0]
      ),
      language: (
        /*language*/
        t[1]
      )
    }
  }), e.$on(
    "language-change",
    /*language_change_handler*/
    t[16]
  ), e.$on(
    "open-change",
    /*open_change_handler*/
    t[17]
  ), {
    c() {
      D(e.$$.fragment);
    },
    m(l, c) {
      I(e, l, c), n = !0;
    },
    p(l, c) {
      const i = {};
      c & /*realms*/
      4 && (i.realms = /*realms*/
      l[2]), c & /*realm*/
      1 && (i.realm = /*realm*/
      l[0]), c & /*language*/
      2 && (i.language = /*language*/
      l[1]), e.$set(i);
    },
    i(l) {
      n || (v(e.$$.fragment, l), n = !0);
    },
    o(l) {
      T(e.$$.fragment, l), n = !1;
    },
    d(l) {
      U(e, l);
    }
  };
}
function jn(t) {
  let e, n, l, c, i, a, r, s, g, m, d, h = !/*isCn360*/
  t[10] && !/*isWithoutRealms*/
  t[11] && Yn(t);
  return c = new Pn({
    props: {
      legalLinks: (
        /*legalLinks*/
        t[3]
      ),
      onClickByLink: (
        /*onClickByLink*/
        t[9]
      )
    }
  }), a = new On({
    props: {
      copyrightText: (
        /*copyrightText*/
        t[6]
      ),
      realm: (
        /*realm*/
        t[0]
      )
    }
  }), s = new Hn({
    props: { legalText: (
      /*legalText*/
      t[5]
    ) }
  }), m = new Kn({
    props: {
      logosAndRatings: (
        /*logosAndRatings*/
        t[4]
      ),
      onClickByLink: (
        /*onClickByLink*/
        t[9]
      )
    }
  }), {
    c() {
      e = N("footer"), n = N("div"), h && h.c(), l = M(), D(c.$$.fragment), i = M(), D(a.$$.fragment), r = M(), D(s.$$.fragment), g = M(), D(m.$$.fragment), _(n, "class", "wcf-inner-container"), _(e, "class", "wcf-theme wcf-main-container"), b(
        e,
        "cn360",
        /*isCn360*/
        t[10]
      ), b(
        e,
        "without-realms",
        /*isWithoutRealms*/
        t[11]
      );
    },
    m(o, u) {
      R(o, e, u), S(e, n), h && h.m(n, null), S(n, l), I(c, n, null), S(n, i), I(a, n, null), S(n, r), I(s, n, null), S(n, g), I(m, n, null), d = !0;
    },
    p(o, [u]) {
      !/*isCn360*/
      o[10] && !/*isWithoutRealms*/
      o[11] && h.p(o, u);
      const L = {};
      u & /*legalLinks*/
      8 && (L.legalLinks = /*legalLinks*/
      o[3]), u & /*onClickByLink*/
      512 && (L.onClickByLink = /*onClickByLink*/
      o[9]), c.$set(L);
      const C = {};
      u & /*copyrightText*/
      64 && (C.copyrightText = /*copyrightText*/
      o[6]), u & /*realm*/
      1 && (C.realm = /*realm*/
      o[0]), a.$set(C);
      const Z = {};
      u & /*legalText*/
      32 && (Z.legalText = /*legalText*/
      o[5]), s.$set(Z);
      const B = {};
      u & /*logosAndRatings*/
      16 && (B.logosAndRatings = /*logosAndRatings*/
      o[4]), u & /*onClickByLink*/
      512 && (B.onClickByLink = /*onClickByLink*/
      o[9]), m.$set(B);
    },
    i(o) {
      d || (v(h), v(c.$$.fragment, o), v(a.$$.fragment, o), v(s.$$.fragment, o), v(m.$$.fragment, o), d = !0);
    },
    o(o) {
      T(h), T(c.$$.fragment, o), T(a.$$.fragment, o), T(s.$$.fragment, o), T(m.$$.fragment, o), d = !1;
    },
    d(o) {
      o && k(e), h && h.d(), U(c), U(a), U(s), U(m);
    }
  };
}
function Jn(t, e, n) {
  var X, V, re, Te;
  let { realm: l = y.EU } = e, { language: c = "en" } = e, { version: i } = e, { overrides: a } = e, { reduceRealmLanguages: r = (A) => A } = e, { reduceLegalLinks: s = (A) => A } = e, { realms: g = (a == null ? void 0 : a.realms) ?? r(Fn()) } = e, { legalLinks: m = s(((X = a == null ? void 0 : a.legalLinks) == null ? void 0 : X[c]) ?? an({ realm: l, language: c })) } = e, { logosAndRatings: d = ((V = a == null ? void 0 : a.logosAndRatings) == null ? void 0 : V[c]) ?? zt({ realm: l, language: c }) } = e;
  const h = xt({ realm: l, language: c });
  let { legalText: o = ((re = a == null ? void 0 : a.legalText) == null ? void 0 : re[c]) ?? h.legalText } = e, { copyrightText: u = ((Te = a == null ? void 0 : a.copyrightText) == null ? void 0 : Te[c]) ?? h.copyrightText.replace("{version}", i) } = e, { onLanguageChange: L = () => {
  } } = e, { onLanguagePickerOpenChange: C = () => {
  } } = e, { onClickByLink: Z = () => {
  } } = e, B = l === y.CN360, w = !g.length;
  const P = (A) => L(A.detail), H = (A) => C(A.detail);
  return t.$$set = (A) => {
    "realm" in A && n(0, l = A.realm), "language" in A && n(1, c = A.language), "version" in A && n(12, i = A.version), "overrides" in A && n(13, a = A.overrides), "reduceRealmLanguages" in A && n(14, r = A.reduceRealmLanguages), "reduceLegalLinks" in A && n(15, s = A.reduceLegalLinks), "realms" in A && n(2, g = A.realms), "legalLinks" in A && n(3, m = A.legalLinks), "logosAndRatings" in A && n(4, d = A.logosAndRatings), "legalText" in A && n(5, o = A.legalText), "copyrightText" in A && n(6, u = A.copyrightText), "onLanguageChange" in A && n(7, L = A.onLanguageChange), "onLanguagePickerOpenChange" in A && n(8, C = A.onLanguagePickerOpenChange), "onClickByLink" in A && n(9, Z = A.onClickByLink);
  }, [
    l,
    c,
    g,
    m,
    d,
    o,
    u,
    L,
    C,
    Z,
    B,
    w,
    i,
    a,
    r,
    s,
    P,
    H
  ];
}
class zn extends Y {
  constructor(e) {
    super(), F(this, e, Jn, jn, K, {
      realm: 0,
      language: 1,
      version: 12,
      overrides: 13,
      reduceRealmLanguages: 14,
      reduceLegalLinks: 15,
      realms: 2,
      legalLinks: 3,
      logosAndRatings: 4,
      legalText: 5,
      copyrightText: 6,
      onLanguageChange: 7,
      onLanguagePickerOpenChange: 8,
      onClickByLink: 9
    });
  }
}
class Wn {
  info(...e) {
    console.log("[WCF]", ...e);
  }
}
const qn = new Wn();
async function Qn({
  language: t,
  rootUrl: e = "",
  dictionaryCatalog: n
}) {
  if (n)
    ge.catalog = n;
  else {
    const l = `${e || ""}/locales/${t}.json`;
    try {
      const c = await fetch(l);
      ge.catalog = await c.json();
    } catch {
      qn.info("Failed to fetch locales");
    }
  }
}
async function xn({
  selector: t,
  legalLinks: e,
  copyrightText: n,
  legalText: l,
  dictionaryCatalog: c,
  language: i,
  realms: a,
  realm: r,
  onLanguageChange: s,
  onLanguagePickerOpenChange: g,
  onClickByLink: m,
  version: d,
  rootUrl: h,
  overrides: o,
  reduceRealmLanguages: u,
  reduceLegalLinks: L,
  logosAndRatings: C
}) {
  Object.keys(ge.catalog).length || await Qn({
    language: i,
    rootUrl: h,
    dictionaryCatalog: c
  }), new zn({
    target: document.querySelector(t),
    props: {
      legalLinks: e,
      copyrightText: n,
      legalText: l,
      language: i,
      realms: a,
      realm: r,
      onLanguageChange: s,
      onLanguagePickerOpenChange: g,
      onClickByLink: m,
      version: d,
      overrides: o,
      reduceRealmLanguages: u,
      reduceLegalLinks: L,
      logosAndRatings: C
    }
  });
}
export {
  p as LegalLinkNames,
  xn as createFooter,
  ln as getLegalLinks,
  an as getLegalLinksFallback,
  Qn as initDictionaryCatalog
};
